//Do not remove this const descriptions = [
const descriptions = [
  
  
      {
        product_name: "lucky_koi",
        product_id: "4399026733122",
        product_text: "Mesmerizing and mystical lucky koi fish practically dance off your canvas in this fluid and stirring piece. Splish, splosh, splash! Lily pads and flowers embrace, guiding these majestic fish through the sparkling water."
      },
      {
        product_name: "confetti_the_cat",
        product_id: "4399025291330",
        product_text: "Meow! This handsome kitty with white whiskers and a confetti of color bespeckling its face is a joy to recreate and bring to life. Although full of color, this cat is very realistic, appealing to most as a diamond painting."
      },
      {
        product_name: "dreams_of_elysium",
        product_id: "4399016804418",
        product_text: "Step into a fairytale setting bursting with the vibrant and youthful colors of spring. You can almost hear the chatter of wildlife that whips and weaves out of sight as you stroll across a majestic bridge and into Elysium."
      },
      {
        product_name: "fine_soft_day",
        product_id: "4399009988674",
        product_text: "How alive the gardens feel after a rain! You can practically see the flowers blooming before your eyes, and the gentle stream is bubbling in delight. From a fine soft day, evening now begins to set in at this country cottage, and the fires are lit."
      },
      {
        product_name: "reverie",
        product_id: "4399016083522",
        product_text: "Lose yourself in a magical reverie as evening sets in across the valley. Walk by the wildflowers and out onto a still, peaceful lake to feast your eyes upon the moonlit snowy peaks of the mountains ahead. Breathe in that clean air as the first stars break through the pink and purple sky."
      },
      {
        product_name: "tawny_owl",
        product_id: "4399029256258",
        product_text: "A bright, bold, and bejeweled tawny owl captures a look of realism with a cute and colorful cartoonish pop. The final effect melts your heart and makes you smile."
      },
      {
        product_name: "when_september_ends",
        product_id: "1597154426946",
        product_text: "A picturesque autumnal day. When September ends, the days are still bright and blue while the trees proudly pop pinks, reds, and deep oranges. Light and passing rains transform a regular sidewalk into an ocean of color to glide across."
      },
      {
        product_name: "lily_lagoon",
        product_id: "4399027126338",
        product_text: "Zoom in and get close up with nature, enjoying the fine detail created in smooth, artistic strokes. Lily Lagoon holds a brilliant purple lily in court, beautifully contrasted by vibrant greens and blues and complemented with the yellows of young buds."
      },
      {
        product_name: "vibrant_roses",
        product_id: "4399020638274",
        product_text: "A dreamy, soft depiction of three beautifully rendered roses, artfully detailed with white to accentuate their delicacy and splendor. Vibrant leaves in deep blues make the flowers pop even further, drawing you in and engulfing you in their rich splendor."
      },
      {
        product_name: "forgotten_memories",
        product_id: "4399018737730",
        product_text: "With sunlight streaming through the trees, an overgrown and forgotten yet majestic iron bench from memories long ago is placed in the spotlight. Enjoy the array of colors found in the spring flowers at your feet and the bright leaves from above."
      },
      {
        product_name: "flamingo_falls",
        product_id: "4399019720770",
        product_text: "When we think of flamingos, we think of cotton candy pink, and here, you aren’t disappointed. Offset by a deep, vibrant blue of a waterfall and pool and complemented by popping blossoms in the distance, the flamingo holds court in this dreamy scene."
      },
      {
        product_name: "contemplation",
        product_id: "4399013888066",
        product_text: "This cozy bench is waiting for you in solitude, inviting you to a moment of contemplation. Allow the calm, still waters of the pond to ease your mind as the sunlight warms your face through the glowing, orange leaves of a tree."
      },
      {
        product_name: "yoshi_the_shiba",
        product_id: "4399028863042",
        product_text: "This gorgeous depiction of Yoshi the Shiba Inu has been brightly recreated by Sandra Trubin and is just perfect for a diamond painting. The bright colors and clear features allow for a fun journey where you can watch this cute puppy come alive before your eyes!"
      },
      {
        product_name: "exuberance",
        product_id: "1597137813570",
        product_text: "The skeleton of a tree holds court as a party of color carries on all around. In the background, more trees, bare and broken, stand defiant against the bright exuberance, like soldiers bravely standing their ground as shrapnel falls around them."
      },
      {
        product_name: "the_winter_cabin",
        product_id: "4399019884610",
        product_text: "Smooth and dreamy purples and blues embrace a winter cabin that stands alone, save for a giant winter pine speckled with the remnants of a snowfall dance. From the mountains in the distance to the delicate flowers in the foreground, you are taken on a reflective, watery ride of wintery melt and icy dreams."
      },
      {
        product_name: "a_bridge_to_cross",
        product_id: "4399017951298",
        product_text: "In the distance, there is nothing but a bridge to cross, with the river stretching far and wide on either side. Colorful trees hug the sturdy path and line the way for you to follow."
      },
      {
        product_name: "dreamcatcher",
        product_id: "4399017427010",
        product_text: "Imagine stumbling across this extravagant dreamcatcher hung purposefully in the woods. Allow your thoughts and wishes to hang here also as you wander the colorful path toward the unknown."
      },
      {
        product_name: "first_winter",
        product_id: "4399021686850",
        product_text: "A baby deer stands ready and willing to take on its first winter, its soft, brown eyes brimming with determination. Long streaks in the background of the winter are skeletons of trees, and coupled with the soft fluffing of snow on the ground, show the contrasts and diversity that winter has to bring."
      },
      {
        product_name: "autumn_waters",
        product_id: "4399019294786",
        product_text: "The oak trees turn orange and pink as the autumn waters feed the calm yet swollen river. Warm hues take precedence here, although you can feel the temperatures beginning to drop as the seasons turn and nature concedes."
      },
      {
        product_name: "grumpy_cat_van_gogh_limited_edition",
        product_id: "1597161209922",
        product_text: "Thick brushstrokes inspired by Van Gogh recreate the internet sensation ‘Grumpy Cat’ like never before. Background swirls of blue complement this cat’s stunning eyes. Don’t let the cat fool you, this painting is a whole lot of fun!"
      },
      {
        product_name: "rainbow_falls",
        product_id: "1597311615042",
        product_text: "A waterfall cascades down exposed rock, where cave pools are hinted at in the depths of the water below. A forest of trees lets through a little light, but just wait for Rainbow Falls once the darkness breaks!"
      },
      {
        product_name: "peaceful_evening",
        product_id: "4399008579650",
        product_text: "There’s nothing quite like a peaceful evening where the lawns are mowed, the hedges are trimmed, and the cute cottage stands warm and welcoming against a setting sun. Come on in and enjoy a cup of tea with your feet against the blissful fire."
      },
      {
        product_name: "lion_kingdom",
        product_id: "4399027585090",
        product_text: "Warm, bright colors pop against this dominating face of the king of the jungle. This lion’s eyes draw you in and it’s difficult to pull away. Enjoy working through this diamond painting and bringing this lion to life!"
      },
      {
        product_name: "scarlet_macaw",
        product_id: "4399028731970",
        product_text: "Famous for their rainbow display, a scarlet macaw is your painting of choice if you’re looking for color and vibrancy. A fantastic dance for your eyes, bringing you from one space to another, the clean lines of this parrot will keep you captivated for hours."
      },
      {
        product_name: "bunny_friends_forever",
        product_id: "4399024504898",
        product_text: "A gorgeous baby bunny coupled with a whimsical hummingbird - can it get any cuter? Enjoy the artistic lines and swirls with your painting before catching the bunny’s eye and simply melting inside."
      },
      {
        product_name: "rainbow_stallion",
        product_id: "4399021326402",
        product_text: "A simply stunning portrayal of a stallion’s force silhouetted against a forest of rainbows, from both above and below. A multitude of different colors held in the leaves is reflected against a pond, doubling the effect of this eye-catching piece."
      },
      {
        product_name: "freddy_the_frog",
        product_id: "4399028535362",
        product_text: "Definite, clean lines paint a picture of Freddy the frog for you to enjoy. He sits on a dark green lily pad, and brightly contrasted with orange, this lime-green frog is both cute and captivating."
      },
      {
        product_name: "mischievous_wolf_grin",
        product_id: "4399030009922",
        product_text: "Lock eyes with this mischievous wolf and you’ll find it difficult to look away. The cute grin she wears makes it hard for you not to smile. Coupled with the spectacular colors on display in her thick coat and beyond, you will be enchanted for hours."
      },
      {
        product_name: "tiger_trance",
        product_id: "4399029649474",
        product_text: "If it isn’t the eyes and the intensity of that stare, it’s the swirls in their markings that hypnotize in this tiger trance. Coupled with the spectacular colors within the coat, you’ll find yourself enchanted for hours."
      },
      {
        product_name: "winston_the_frenchie",
        product_id: "4399026307138",
        product_text: "Sir Winston Charles, otherwise known as Winston the Frenchie, is an Instagram and YouTube sensation. His adorable smiling face has been captured in this colorful depiction, making for a fun-filled experience."
      },
      {
        product_name: "deer_in_the_moonlight",
        product_id: "4399025979458",
        product_text: "A white moon in the background surrounds the stately face of this majestic creature. A deer with enormous horns creates curves and balance in this bright, colorful piece."
      },
      {
        product_name: "eleanor_the_elephant",
        product_id: "4399026241602",
        product_text: "Realistic yet with splashes of every hue to spark the imagination and entertain, Eleanor the elephant holds your attention and invokes timeless elegance and power in her gaze."
      },
      {
        product_name: "sunset_sail",
        product_id: "4399022276674",
        product_text: "A beautiful artistic piece using an unusual method to create a crackled appearance of the final scene. As sunset deepens over the sea, darkness encroaches, where the silhouette of a sailboat stands boldly atop the vibrantly-lit sea."
      },
      {
        product_name: "breath_of_dawn",
        product_id: "4399002288194",
        product_text: "The pink stillness of dawn breathes life into this quietly breathtaking image, when the coldness of the night is only just starting to give way. You can almost see your breath fog before you, misting your view of this watery, moving piece."
      },
      {
        product_name: "winters_song",
        product_id: "4399021162562",
        product_text: "With winter comes harsh, savage songs sung by all who bear witness to the crisp stillness that descends. Moving purples and yellows dominate the sky and are reflected by the frozen pond, where skeletal soldiers of trees and tough, bristled bushes endure this frozen, icy landscape."
      },
      {
        product_name: "panda_snacks",
        product_id: "4399028076610",
        product_text: "Yum, yum! A fluffy panda, with deep fingerfuls of fur, is munching on their favorite snack: bamboo! Blues and yellows bring depth to this beautiful panda’s face, while the brighter background colors allow it to truly pop."
      },
      {
        product_name: "libertys_light_trial",
        product_id: "4606948999234",
        product_text: "A single star on a blue background and the unmistakable stripes of the majestic American flag adorn the roof and tower of this humble yet proud lighthouse. Set on a rocky outcrop, stairs lead from the shore to the door."
      },
      {
        product_name: "over_the_rainbow_trial",
        product_id: "4399033679938",
        product_text: "A breathtaking rainbow of colors adorns this realistically altered photo of a rose. From the fresh growth of petals just emerging from the depths of the flower to those now drying and curling at the edges, this picture of perfection is simply absorbing."
      },
      {
        product_name: "twisted_blossom_trial",
        product_id: "4399033516098",
        product_text: "A gnarled and twisted blossom adds a haunting element of depth to this otherwise cheerful and bright pink-hued sunset over a lake. Complete with a lone swan, carving a line atop the still waters, there is detail and beauty in every inch of this piece."
      },
      {
        product_name: "butterfly_orchid_fantasy_trial",
        product_id: "4399032139842",
        product_text: "Both butterfly and orchid appear as a single being, defined only by their distinct colors in this masterful piece. Allowing us to rediscover the unity in nature, as well as its detail and precision, is both enjoyable to recreate and comforting to the eye."
      },
      {
        product_name: "cottage_on_the_water",
        product_id: "4697568444482",
        product_text: "This cottage on the water is a delightful ensemble of paving stones, roses, and quaint cottage windows. The water can lap at your toes as you sit at the path’s edge to soak in the old English charm. "
      },
      {
        product_name: "english_garden_with_trellis",
        product_id: "4697568739394",
        product_text: "Light and airy, the cloudless blue sky allows you to see far and wide through the English garden and to the village and hills beyond. Take a walk through the rose-laden archway to sit in your own private courtyard, where you can enjoy the sights and smells of this glorious setting."
      },
      {
        product_name: "patio_for_two",
        product_id: "4697569755202",
        product_text: "Ding ding! Ring the bell for more tea! Out in the sun, chairs are waiting, but a path through the grass leads to a quaint gazebo, nestled in the garden blooms. Take your pick from where to enjoy the view across the water and hills beyond on this patio for two. "
      },
      {
        product_name: "patio_with_baskets",
        product_id: "4697569984578",
        product_text: "Old English charm that takes your breath away. A place of pure tranquility, this patio with enough cozy white wicker armchairs to spoil you for choice invites you to take in the scene beyond. Hanging and placed pot plants in bloom bring the beauty of the outdoors in with you, but feast your eyes upon the meadows, still ponds, and blooming bushes."
      },
      {
        product_name: "patio_with_flowers",
        product_id: "4697570181186",
        product_text: "Here on this patio with flowers, everything is at your fingertips. Chance upon a book that takes your fancy, pick at a selection of fine fruits, or curl up with a blanket and a tea and watch the bright and soft day pass before your eyes in this calm and peaceful setting. "
      },
      {
        product_name: "sunflowers",
        product_id: "4697570639938",
        product_text: "Nothing says summer like a vase full of sunflowers. This traditional painting is brought alive by the theme of summer, featuring ripe, fresh fruits, a sunhat, and blooming droplets of white and blue for an array of color that’s sure to brighten anyone’s day. "
      },
      {
        product_name: "the_good_life",
        product_id: "4697570934850",
        product_text: "This is the good life. After a pleasant afternoon of picking choice flowers from the vast selection on offer in this lakeside garden, you’re invited to take a load off and cool down with a long drink. The dove cove draws the eye as you peer through the archway of bright blue flowers."
      },
      {
        product_name: "wine_on_the_window",
        product_id: "4697571328066",
        product_text: "White or red? The choice is yours. You’re perched high here, looking out of the window and across fields and farms, from one village to the next. There’s a real feeling of serenity and solitude here, so sit back and take it all in, one sip at a time."
      },
      {
        product_name: "burano_e_i_colori",
        product_id: "4696690491458",
        product_text: "The vivid colors of house and home are reflected back at you from the rippling waters of the canal. With boats tied at each side and the bridge well worn, you know this small city is brimming with life, although at this moment, only peaceful solitude is to be found."
      },
      {
        product_name: "i_entrata_al_borgo",
        product_id: "4696689606722",
        product_text: "The aged and muted colors of yesteryear allow us to take a step back in time in this European historic village. With sparks of color drawing the eye thanks to the pots of flowers dotted across the path, up stairs, and on balconies, there’s a skip in your step as you walk the warm stones of the path through town."
      },
      {
        product_name: "i_vasi_dietro_la_grata",
        product_id: "4696689836098",
        product_text: "Imagine turning a corner and chancing upon this spectacular little front door grotto. Pots and vases line every inch of space, marking the home for a brilliant display of life in an otherwise whitewashed and sun-bleached landscape. The archway of leaves over the wooden door is an especially lovely touch."
      },
      {
        product_name: "laltra_porta_rossa_al_tramonto",
        product_id: "4696697962562",
        product_text: "Rich, ruby-red flowers adorn the building walls, threatening to come in through the green-cased windows several stories up. Take a walk up the gentle steps into town to discover more bursts of life that take over the European styled village with ease. "
      },
      {
        product_name: "la_porta_rossa_sulla_salita",
        product_id: "4696697110594",
        product_text: "It’s another warm and bright day in this traditional Italian town. Climbers hang from every window and creep around doors - the only life seen in the stillness of the day’s lazy heat."
      },
      {
        product_name: "le_scale_tra_le_case",
        product_id: "4696685477954",
        product_text: "Roughly translating to ‘the stairs between the houses’, you are taken on a journey here from house to house, level to level, and color to color, the light blue doors prominent against the terracotta orange and fading light in the sky."
      },
      {
        product_name: "santorini_a_colori",
        product_id: "4696690393154",
        product_text: "Santorini in color. A beautiful sight, this island is home to whitewashed, cubiform buildings that reflect the intensity of the sun. Splashes of color about the buildings are an opportunity for expression and joyousness, and this is exactly what you will find here."
      },
      {
        product_name: "un_soggiorno_a_venezia",
        product_id: "4696689770562",
        product_text: "Come and enjoy a stay in Venice; your room awaits! Peek out the balcony to see the canal right at your feet and the houses towering up on either side. A place like no other, enjoy this cultural depiction artfully recreated."
      },
      {
        product_name: "bohemian_peacock",
        product_id: "4697580077122",
        product_text: "Is there a better way to say ‘you’re amazing’? Bright, bold, and fun colors are always found in the beautiful peacock with cute heart and flower details, adding that finishing touch."
      },
      {
        product_name: "bunny_basket",
        product_id: "4697576669250",
        product_text: "A cute and colorful Easter surprise awaits here, as the sweetest cartoon baby bunny and their little chick friends bring a basket of colored eggs for all to enjoy. The bright tulips in the background add to the vibrant seasonal energy."
      },
      {
        product_name: "country_mailbox",
        product_id: "4697578078274",
        product_text: "Is it a postbox or a birdhouse? It’s difficult to tell with this country mailbox. Owned by typically proud and patriotic folk, the mailbox is painted as a flag, and colorful birds of all species will delight as you work through this painting."
      },
      {
        product_name: "dream_big",
        product_id: "4697581092930",
        product_text: "With an important message that we all need to heed, the whimsical and bohemian vibe complements this dreamcatcher. With butterflies and stars and mandalas creeping in from the sides, there’s nothing more to do but dream big. "
      },
      {
        product_name: "follow_your_heart",
        product_id: "4697580470338",
        product_text: "North, south, east, or west? When you’re told to follow your heart, love is in every direction! Bright and cute colors will keep you smiling as you work through this piece."
      },
      {
        product_name: "lighthouse_cottage",
        product_id: "4697578864706",
        product_text: "What a quaint lighthouse cottage sitting here by the sea. Complete with a white picket fence, cat on the doorstep, and colorful flowers creeping over the stone walls and across the path, if it wasn’t for the seagulls, you could be mistaken for being in the countryside!"
      },
      {
        product_name: "penguin_trio",
        product_id: "4697577652290",
        product_text: "Season’s Greetings. This penguin trio seems to be busy decorating their tree, hanging stars and decorations as the snowflakes fall around them. Being so up close and personal brings more warmth to the setting, making for a fun choice for artists of all ages."
      },
      {
        product_name: "pot_puppy",
        product_id: "4697577488450",
        product_text: "There won&#x27;t be much more work done in the garden now with a puppy on the loose! There’s certainly a lot of activity going on, with a bright display of flowers, butterflies, and even a sweet hummingbird!"
      },
      {
        product_name: "pumpkin_pals",
        product_id: "4697579257922",
        product_text: "Who said Halloween had to be scary? Cute black kittens play around a smiling pumpkin carving, surrounded by other seasonal fruits and flowers. The fall colors are always breathtaking, and during this season, we can begin enjoying these together."
      },
      {
        product_name: "rustic_fence",
        product_id: "4697578602562",
        product_text: "A rustic fence is almost swallowed by a vibrant and colorful cottage garden full of flowers, butterflies, and birds. The setting sun in the background complements the colors nicely and allows the bright shades of bird feathers to really pop."
      },
      {
        product_name: "spread_your_wings",
        product_id: "4697580896322",
        product_text: "Welcome, come on over and spread your wings. A dark and night-like background allows the beautiful wreath of pink flowers to stand out, encasing two beautiful hummingbirds that inspire you to soar."
      },
      {
        product_name: "starshine_snowman",
        product_id: "4697575915586",
        product_text: "Such a cherry face on this rotund and jolly snowman brings goodwill and happiness to all during the holidays. A falling star for luck, mistletoe for love, and is it snowing? Nothing could be more perfect."
      },
      {
        product_name: "distant_dreams",
        product_id: "4696742854722",
        product_text: "A lighthouse is featured in the distance as waves crash out onto the rocks. But these are all distant dreams here at a beachside villa, grand and whitewashed against the salt air. If you wish to dip your toes into the sea, cross the grassy, flower-bespeckled dunes and soft sand when the tide comes in again."
      },
      {
        product_name: "lighting_the_way",
        product_id: "4696749441090",
        product_text: "A turbulent sky casts a final splash of light over waves as they slip up to shore. The lighthouse and cottage are already aglow, lighting the way for any wayward sailors."
      },
      {
        product_name: "poetic_light",
        product_id: "4696763400258",
        product_text: "This lighthouse, built in stone, shines out through the dimming light of day, casting an eerie glow on the sands and salt below. The lighthouse keeper enjoys the best of both worlds, with fresh green grass and the gentle sound of the wind in the trees to enjoy alongside the lapping of the sea at his doorstep."
      },
      {
        product_name: "rhapsody_in_blue",
        product_id: "4696757567554",
        product_text: "A unique take on the traditional still life, this table and shelf are full of humble trinkets and necessities for the avid gardener. Pots, birdhouses, trowels, and the unmistakable influence of a patriotic American, this is a rhapsody in red, white, and blue."
      },
      {
        product_name: "seasons_greetings",
        product_id: "4696760778818",
        product_text: "The claws of winter can have a deathly grasp, stripping trees of life and throwing the landscape into a cold, icy embrace. But nothing can dampen the Christmas spirit, so season’s greetings from a father and son snowman, smiling brightly through this cold, frozen night!"
      },
      {
        product_name: "smooth_sailing",
        product_id: "4696746426434",
        product_text: "It’s smooth sailing here where waves glide gently up onto shore. Still, the lighthouse is vast and bright in the setting sun, and there’s even a low slung chair waiting for you to sit and watch the boats sail by."
      },
      {
        product_name: "sweet_surrender",
        product_id: "4696751636546",
        product_text: "A well-kept and stately lighthouse sits proudly high up on a cliff, overlooking building clouds out to sea. What is to come one can only surrender to, but at least you can find safety here."
      },
      {
        product_name: "the_boat_house",
        product_id: "4696764874818",
        product_text: "Moody colors dominate this scene as the boat house sits, weathered and well-used, back off the encroaching waves of the tide. Plentiful herbs and flowers hug the fences and paths, softening the otherwise wood-littered space."
      },
      {
        product_name: "ancient_heart",
        product_id: "4696705105986",
        product_text: "A Mayan-style headdress adorns a fierce, dark-eyed beauty as she sits in front of a temple. The bright color of the setting sun adds contrast to the natural hues of greens. Strong and powerful, this painting is both absorbing and mystifying."
      },
      {
        product_name: "angel_wings",
        product_id: "4696707563586",
        product_text: "A golden-haired cherub of a princess, with soft cheeks blushed the shade of her gown and a heart at her throat, sits atop the clouds, as pure as they come."
      },
      {
        product_name: "angel_cake",
        product_id: "4696709529666",
        product_text: "With a stunning color choice of lilac and tangerine, a heart-lipped beauty stands with her furry friend and a cake for all. Her doe eyes seem to be able to look straight through you while simultaneously drawing you in."
      },
      {
        product_name: "jasmine",
        product_id: "4696713494594",
        product_text: "Jasmine is soft-eyed and stunning, but with a hint of sadness - an angel who has seen more than you know. Her thick, blue fishtail braid hangs down to her waist, matching her star-spangled dress, with more stars as her crown."
      },
      {
        product_name: "kindred_spirit",
        product_id: "4696720408642",
        product_text: "Spend a dreamy day on the farm with this freckled and red-haired farm girl - a kindred spirit to many. When not picking bunches of wildflowers or working the fields, you’ll find her with a nose in her book or watching the clouds roll by."
      }, 
      {
        product_name: "mary_poppins_jolly_holiday",
        product_id: "4696722243650",
        product_text: "Here sits Mary Poppins atop what else but a merry-go-round horse, proudly free of its circular prison. Swirls and whorls of flowers at their feet bring your eye up and out toward the mystical night and the comforting sway of trees."
      },  
      {
        product_name: "miss_turf_ace",
        product_id: "4696716476482",
        product_text: "Cute and sassy, Miss Turf Ace knows how to look after herself and her land. With her trusty pooch aboard, she cruises around, tending to all she comes across."
      }, 
      {
        product_name: "patience",
        product_id: "4696718377026",
        product_text: "This feather-lashed mermaid exudes calm and patience as she poses aloft out of the water with a sleeping dove in hand. Curling limbs of trees against a dark blue sky bring a magical tone to this soft and sweet scene."
      },
      {
        product_name: "seraphina",
        product_id: "4696715591746",
        product_text: "This mystical witch and her white-whiskered black cat have been enjoying some seasonal merriment, carving Halloween snowmen out of pumpkins of all shapes and sizes. A wicked princess, Seraphina is both sweet and scary."
      },  
      {
        product_name: "spring_beauty",
        product_id: "4696729059394",
        product_text: "Kissed by blooming flowers and lovingly caressed by butterflies, this spring beauty shines brightly, with turquoise wings that complement her gown of roses as she sits among the vibrant blossoms of springtime."
      },  
      {
        product_name: "twisted_blossom_large",
        product_id: "1597150167106",
        product_text: "A gnarled and twisted blossom adds a haunting element of depth to this otherwise cheerful and bright pink-hued sunset over a lake. Complete with a lone swan, carving a line atop the still waters, there is detail and beauty in every inch of this piece."
      },  
      {
        product_name: "over_the_rainbow_large",
        product_id: "4697583026242",
        product_text: "A breathtaking rainbow of colors adorns this realistically altered photo of a rose. From the fresh growth of petals just emerging from the depths of the flower to those now drying and curling at the edges, this picture of perfection is simply absorbing."
      },   
      {
        product_name: "twisted_blossom",
        product_id: "4707306733634",
        product_text: "A gnarled and twisted blossom adds a haunting element of depth to this otherwise cheerful and bright pink-hued sunset over a lake. Complete with a lone swan, carving a line atop the still waters, there is detail and beauty in every inch of this piece."
      },   
      {
        product_name: "over_the_rainbow",
        product_id: "4707303948354",
        product_text: "A breathtaking rainbow of colors adorns this realistically altered photo of a rose. From the fresh growth of petals just emerging from the depths of the flower to those now drying and curling at the edges, this picture of perfection is simply absorbing."
      },  
      {
        product_name: "libertys_light",
        product_id: "4707304538178",
        product_text: "A single star on a blue background and the unmistakable stripes of the majestic American flag adorn the roof and tower of this humble yet proud lighthouse. Set on a rocky outcrop, stairs lead from the shore to the door."
      },      
      {
        product_name: "butterfly_orchid_fantasy",
        product_id: "4707306176578",
        product_text: "Both butterfly and orchid appear as a single being, defined only by their distinct colors in this masterful piece. Allowing us to rediscover the unity in nature, as well as its detail and precision, is both enjoyable to recreate and comforting to the eye."
      },  
      {
        product_name: "sumatran_tiger",
        product_id: "4398999830594",
        product_text: "Realistic, powerful, and engaging, this Sumatran tiger is sure to turn heads as it lounges across your canvas. The slightly muted colors create a mystical look that complements the impressive energy this beast possesses."
      },
      {
        product_name: "portals_of_the_past",
        product_id: "4399005171778",
        product_text: "Set back among shadowed and misty trees, Roman columns frame unknown portals of the past. You are drawn into the bright and barely perceivable entranceway and beyond, past the gently rippling pond of lily pads bathed in late evening light."
      },
      {
        product_name: "perseverance",
        product_id: "6539078041666",
        product_text: "Slightly whitewashed edges focus your gaze at the center of this masterpiece. Here sits a young yet fully opened lilac-colored rose that holds your attention as the flower stares straight at you. Other blooms facing gently away allow your eyes to take in the whole magnificent bouquet."
      },  
      {
        product_name: "under_the_rainbow",
        product_id: "6539079188546",
        product_text: "This painting has it all, from mountains to beaches, birds flying in the sky to schools of fish in the water. Intricate detail is found where scores of life flourish in the vibrant coral. And all this is happening under a rainbow!"
      },   
      {
        product_name: "the_old_waterway_cottage",
        product_id: "6539084955714",
        product_text: "An angled bridge over a gentle stream is slowly engulfed by creeping waterside flowers of all colors. Join the resident cat and take a walk up the paved path toward the stately old waterway cottage, well maintained and well-loved in a setting deserving of its beauty."
      }, 
      {
        product_name: "hazel",
        product_id: "6539082498114",
        product_text: "Hazel is a witch who simply radiates an electrifying energy. Her lime-green and red hair flies out behind her as she walks forward with all the confidence a young woman of her power would possess. She isn’t complete without her black cat and pentagram, a Halloween pumpkin bag finishing the look."
      },  
      {
        product_name: "owls",
        product_id: "6539087020098",
        product_text: "These owls exude a bohemian benevolence, patterns and swirls adorning their bodies as they peek inquisitively out of the painting and straight into your heart. The muted, natural watercolors suit the softer atmosphere, where the gentle hint of a landscape can be seen in the background."
      },
      {
        product_name: "pirate_princess",
        product_id: "6539077058626",
        product_text: "Set against a background of baby blue and rose petals, this pirate princess has a delicate charm to her face. Holding a space-age laser gun and sporting black wings, this beauty shows that there are always two sides to a person."
      },
      {
        product_name: "elation",
        product_id: "6539087544386",
        product_text: "Rays of light burst through a canopy of trees, shining a spotlight on the life below. The color choice here itself creates a burst of elation to all who view it; pinks, purples, reds, and yellows are further brightened by the magical white rays beaming down."
      },
      {
        product_name: "monarch_madness",
        product_id: "6539086364738",
        product_text: "Just as monarchs are in real life, these radiant and brightly-colored butterflies are of an eye-popping beauty. Behold this monarch madness, where colorful patterns and flowers swamp these orange beauties."
      },
      {
        product_name: "small_town_usa",
        product_id: "6539085316162",
        product_text: "Dusk has been brought on early by a receding shower of rain, not seen in the sky but given away by the mirrored lights of lamps and home. This small town USA sets a slower pace, but is still bustling with activity with cars aplenty and occupied homes lining the street."
      },
      {
        product_name: "realm_of_the_queen",
        product_id: "6539080499266",
        product_text: "This unbalanced scene showcases both the vastness of the sea and the intense diversity that can be found within it. One side is busy with colorful coral, the other is a deep and cavernous blue. Tying the entire piece together is a glorious tropical fish heading straight for us!"
      },
      {
        product_name: "purple_tulips",
        product_id: "6539078402114",
        product_text: "This close_up depiction of a garden thick with purple tulips really allows you to marvel at the detail found in nature, from the deep and dynamic color of each petal to the delicate fragility of the whole flower, artistically shown through confident strokes by this talented artist."
      },
      {
        product_name: "luna_lovegood",
        product_id: "6539081482306",
        product_text: "Loony Lovegood has never looked more beautiful. As she stares deeply back at you, one can only wonder what she can see. There is certainly no underestimating this witch, whatever one might think of her radish earrings and unusual glasses."
      },
      {
        product_name: "end_of_the_rainbow",
        product_id: "6539087708226",
        product_text: "Have you ever wondered what lies at the end of the rainbow? We love how a smattering of flowers absorbs the colors of this rainbow in this rich and regal painting. A sparkling river provides a safe haven for a doe and her fawn as sun-dappled leaves offer depth."
      },
      {
        product_name: "pine_forest_cabin",
        product_id: "6539084202050",
        product_text: "This pine cabin home is rich in fine detail, which makes ordinary objects seem lustrous and lifelike. The color detail in the grass allows you to feel the intensity of the shadows brought forth by the towering and lavishly_barked trees. Bursts of meadow flowers bring you over the quaint bridge and toward the grand villa itself."
      },
      {
        product_name: "the_mixed_bouquet",
        product_id: "6539087085634",
        product_text: "This mixed bouquet is a quirky arrangement of realistic followers and abstract patterns all set in warm oranges, greens, and blues. A few butterflies and dragonflies add movement to an otherwise still image that is nevertheless full of life."
      },
      {
        product_name: "victorian_mansion_grounds",
        product_id: "6539084693570",
        product_text: "Towering brilliance simply takes one’s breath away as you marvel at the Victorian mansion grounds. Crisp hedges and pots of color frame a gushing fountain - one which a black cat walks past with apparent disdain. A lady sits and admires the view, her back to the grandeur that is the mansion itself."
      },
      {
        product_name: "harley",
        product_id: "6539081285698",
        product_text: "Harley Quinn, with the Joker perched on her arm, gazes off into the distance with her brilliant and deep blue eyes. Her long blonde hair is tipped with red and black and pulled up into pigtails, a signature heart adorning her left cheek."
      }, 
      {
        product_name: "sunflower_dreaming",
        product_id: "6539077812290",
        product_text: "The magnificence of a sunflower never fails to impress, and this bouquet of timeless favourites is no exception. Placed in an outdoor setting for a more natural feel, roses and calla lilies also feature in this dreamy sunflower piece."
      },  
      {
        product_name: "tropical_dream",
        product_id: "6539084136514",
        product_text: "As a golden sun sets in the center of this engrossing painting, your eye wanders, constantly finding new beauty to behold. Whether in the detail of the chairs and material, the copious potted flowers adding sparks of color, or the cat lounging at your feet, there is always more to see here."
      }, 
      {
        product_name: "garden_bird_trio",
        product_id: "6539086659650",
        product_text: "A comforting blend of both abstract design and realism, flowers morph into pleasing shapes and patterns in this unique garden bird trio. Everyone will find something different from this piece, but all can agree on the stunning appearance of the three little birds that are perched about."
      }, 
      {
        product_name: "alpine_spring",
        product_id: "6539088134210",
        product_text: "A meadow in the mountain is flush with the brief yet brilliant life that is present only in the Alpine spring. Color is aplenty with an array of hardy varieties out among the green grass, which sits high up amid the cold and desolate mountains."
      }, 
      {
        product_name: "creating_yourself",
        product_id: "6539076599874",
        product_text: "This piece is a whimsical blend of dainty beauty and steampunk quirk. Creating yourself is about the perfection of self-identity, and this blonde beauty is adorning her leg with a floral tattoo. Bounding around her are masked bunnies, further adding to the atmosphere."
      },  
      {
        product_name: "fandango",
        product_id: "6539079680066",
        product_text: "Dive deep below the sea and discover what plays in its depths. Colorful coral provides a sanctuary for schools of fanciful fish - can you spot them all? There’s no missing the curious gaze of that sea turtle!"
      },  
      {
        product_name: "red_riding",
        product_id: "6539082924098",
        product_text: "Here is Little Red Riding, without her hood and the not-so-big bad wolf curled upon her shoulder. Between her shining luscious lips and the unicorn horn from the docile wolf pup’s head, the theme of red is everywhere."
      },
      {
        product_name: "autumn_sun",
        product_id: "6539085938754",
        product_text: "Everything here speaks of autumn to the viewer, from the golden-orange hues of the warm autumn sun to the falling leaves, incessant breeze, and curling and fading petals of the sunflowers. Yes, please!"
      },
      {
        product_name: "gerbera_bouquet",
        product_id: "6539078795330",
        product_text: "Framed by gently opening roses and lilies that are delicately holding their own sits a vibrant and bold Gerbera, face wide open to the world. The brighter pink of the Gerbera is complemented nicely by the deeper reds, soft purples, and natural whites of the entire bouquet, sending your eyes around the canvas before you again marvel at the impressive Gerbera on display."
      },
      {
        product_name: "blonde_cleopatra",
        product_id: "6539086233666",
        product_text: "Her eyeliner-defined eyes bore straight into yours. Adorned with jewels and complete with an owl perched upon one stately finger, this blonde Cleopatra is sure to leave a lasting impression."
      },
      {
        product_name: "symphony",
        product_id: "6539083251778",
        product_text: "These two unicorn babes are a harmonious symphony of bubblegum colors and feathery fragility. Both girl and pony have vibrant eyes that pop out at the viewer, and the choice of jewelry is a well-thought match to the severity of their horns."
      },
      {
        product_name: "the_autumn_farm",
        product_id: "6539084595266",
        product_text: "Welcome to the autumn farm, where pumpkins for sale sit at the gate and muddy tracks lead you toward the traditional barn and farmhouse beyond. Standing in your way is a shining Massey Harris, and as the sky purples into dusk, the final show of floral colors and fading leaves before winter takes grip can be seen."
      },
      {
        product_name: "wrasse_appeal",
        product_id: "6539080597570",
        product_text: "Nearly neon in color, these vibrant varieties of fish pop out of the picture and into your heart. With several species angled toward the viewer, there is a depth in this picture that really emphasizes the vastness of the ocean."
      },
      {
        product_name: "radiant_rainbow",
        product_id: "6539081842754",
        product_text: "Enjoy the eye-popping splendor that is this Radiant Rainbow. This doll of all colors cradles one of her own, her bright yellow hair barely contained behind a bow and a band of rainbow skulls. Even her eyes are an assortment of colors, sharply contrasting against the dark background."
      },
      {
        product_name: "victorian_evening",
        product_id: "6620550037570",
        product_text: "This painting depicts a cool and crisp Victorian evening with a pale blue Victorian villa and sharp pinks of a blossoming tree contrasting with the glowing lights in the windows. A meandering path leads you past a white picket fence overgrown with flowers and saddled horses awaiting passengers to their carriage."
      },
      {
        product_name: "double_trouble",
        product_id: "6620557246530",
        product_text: "Uh-oh! Double trouble! These two cute pups undoubtedly spell mischief among the flower pots. An innocent enough game of ball has spelled disaster as a potted plant has fallen victim to their boisterous game."
      },
      {
        product_name: "lakeside_cottage",
        product_id: "6620560195650",
        product_text: "The cool, crisp colors of this scene contrast with the warmth exuding from the lakeside house through the traditional windows. A table and chairs sit outside on the flower ringed lawn, overlooking a calm and still lake."
      },
      {
        product_name: "waterlilies_of_summer",
        product_id: "6620563144770",
        product_text: "Little specks of white create the illusion of sparkles on a deep, blue expanse of water graced by waterlilies of summer. The strong colors here provide energy and make for an uplifting and enjoyable scene."
      },
      {
        product_name: "spring_stream",
        product_id: "6620552462402",
        product_text: "This spring stream setting simply shouts joy with every fiber as color bursts from everywhere you look. Ducks, deer, swans, and even a squirrel adorn a scene that’s dominated by a variety of springtime flowers and blossoms. A log cabin is warm and inviting against the fresher colors found outside."
      },
      {
        product_name: "joyful_chapel",
        product_id: "6620551479362",
        product_text: "A joyful chapel is composed of crisp, clean white lines, standing proudly in front of a lake teeming with life. A spirited river feeds this lake from a distance, with a farming village seen in the background."
      },
      {
        product_name: "new_generation",
        product_id: "6620554559554",
        product_text: "It’s springtime and the new generation is out in the warm sun, basking on rocks among blossoming mountain flowers. Five wolf pups keep close to the safety of their mother as she surveys the land, perhaps searching for her next hunt target."
      },
      {
        product_name: "serenity_cottage",
        product_id: "6620558655554",
        product_text: "A sturdy brick bridge leads you over a rumbling stream and toward this serene cottage. Bright lights stream out from the large bay windows, inviting you out of the cool springtime dusk and into warmth and comfort."
      },
      {
        product_name: "the_jaguar",
        product_id: "6620555935810",
        product_text: "This mighty and mysterious cat sits comfortably atop a branch, hidden in the darker depths of the jungle. A cascading waterfall is in the background, and splashes of green within the scene reflect the same color in the eyes of the jaguar."
      },
      {
        product_name: "hibiscus_and_hummingbird",
        product_id: "6620562358338",
        product_text: "Splashes of color in the background complement the lines of detail found in both the bold orange hibiscus and the brilliant blues and greens of the sweet and delicate hummingbirds."
      },
      {
        product_name: "the_guiding_light",
        product_id: "6620544991298",
        product_text: "Powerful messages are brought to the fore, with the main focal point of this scene being an eagle illuminated by the setting sun behind it. The guiding glow of a lighthouse can also be seen, with an undoubtedly grateful ship in the distance navigating through rough seas as an imminent storm brews on the horizon."
      },
      {
        product_name: "country_cottage",
        product_id: "6620560490562",
        product_text: "This country cottage is in an idyllic setting, with snowy mountains in the background and horses roaming the lush green pastures that reach a traditional rocky fence. A thatched roof and the blue detailing of the house match the blooming lupins, adding a charming touch."
      },
      {
        product_name: "fairytale_cottage",
        product_id: "6620551053378",
        product_text: "A misty scene allows you to take in much more detail, as this fairytale cottage is certainly a magical place to be. A gentle path from distant hills leads over a bridge, where a horse and carriage awaits on a cobblestone path."
      },
      {
        product_name: "star_birth",
        product_id: "6620553740354",
        product_text: "This whimsical scene of a star birth is set in a pine forest with a floor of field flowers. It also hosts a magnificent white lion with an extravagant mane, along with a somewhat aloof fairy perched on the lion’s back, her hair sporting the same fiery color of the field."
      },
      {
        product_name: "fish_and_jellies",
        product_id: "6620561866818",
        product_text: "The bright orange hues of these fish and jellies are perfectly contrasted by the stunning and abstract background of the deep blue ocean. Cartoon-like elements make this scene fun and bubbly."
      },
      {
        product_name: "english_tudor",
        product_id: "6620561211458",
        product_text: "This stately old manor holds precedence, capturing the last of the evening sun as the cool shadows hit the spring flowers on the grounds. An archway adorned with white flowers brings you up to the door of this elegant English Tudor."
      },
      {
        product_name: "early_snowfall",
        product_id: "6620555313218",
        product_text: "It is an early snowfall, and autumn leaves still cling to the trees while soft snow cascades down to settle on the ground. Two magnificent wolves stand side by side, eyes locked onto something in the distance."
      },
      {
        product_name: "victorian_days",
        product_id: "6620559802434",
        product_text: "This bed and breakfast, built like a castle of the Victorian days, has been kept immaculate. A tree looms up from behind the building with vast grounds opening up into the misty distance. A path, brightly decorated with an assortment of flowers, leads you up the steps to the front door."
      },
      {
        product_name: "sea_turtle_mosaic",
        product_id: "6620562587714",
        product_text: "The interesting abstract design of this sea turtle mosaic graces this underwater spectacle. The multitude of colors found on this magnificent being is broken up by thick lines of white, creating texture and depth."
      },
      {
        product_name: "summertime_mill",
        product_id: "6620551905346",
        product_text: "Cascading water is surrounded by large boulders at this summertime mill. With few open spaces, the close trees, colorful flowers, and blooming bushes all vie for available space, giving the distinct feeling that you’re well away from civilization, where the water flows fresh and clean."
      },
      {
        product_name: "woodland_church",
        product_id: "6620543483970",
        product_text: "A vibrant and elaborate scene bursts with color, a woodland church nestled in a rich autumn landscape. The stained glass window detail of the cottage-esque church is almost seen to reflect the surrounding beauty. There sure is plenty to be thankful for."
      },
      {
        product_name: "noel",
        product_id: "6620555051074",
        product_text: "It’s Christmas time, and the ribbons and tinsel are just too much to bear in this Noel tale. The stunning green eyes of this playful gray cat rolling around underneath the Christmas tree simply captivate us all."
      },
      {
        product_name: "perfect_spring_day",
        product_id: "6620556656706",
        product_text: "This perfect spring day is bursting with the pinks and yellows of blossoming trees and wild field flowers. Galloping through this brilliant landscape are a mare and her foal, heralded by three beautiful doves that complete the softness and innocence of this piece."
      },
      {
        product_name: "autumn_village",
        product_id: "6620549185602",
        product_text: "A roaring campfire, cozy seats and blankets, deep purple sunset skies, a plentiful pumpkin harvest…this autumn village scene exudes warmth and comfort, the houses in the distance all glowing as smoke rises merrily from their chimneys."
      },
      {
        product_name: "boo",
        product_id: "6646700179522",
        product_text: "Standing out from a background of spiderwebs, bordered by candy, is our skeletal main character, coupled with some of his adorable friends. Driving the point home, the word ‘BOO’ is held up on a plaque – because really, these charming characters are anything but scary."
      },
      {
        product_name: "my_secret_brew",
        product_id: "6646702702658",
        product_text: "The love potion you’ve all been waiting for! Here it is, my secret brew. There is an element of magic in the night air as this doe-eyed witch stirs a bubbling concoction and abstract flames lick the cauldron’s side. Don’t forget her trusty companion hanging from the tip of her hat!"
      },
      {
        product_name: "salem",
        product_id: "6646704635970",
        product_text: "As innocent as her heart-shaped face may appear, there’s more than meets the eye with this raven-haired beauty. Her bright golden eyes, popping out of the gloom, are mirrored by her cat’s, as well as by the few objects she possesses that set her apart from the rest."
      },
      {
        product_name: "guiding_lights",
        product_id: "6646706143298",
        product_text: "As warm light spills out from the windows of a church, you wouldn’t be wrong in thinking that many are inside, celebrating a very special moment in the Christian calendar. Snow on the ground glitters in the bright moonlight as unwavering guiding lights, whether it be for sailors or wise men, can be seen from afar."
      },
      {
        product_name: "the_christmas_house",
        product_id: "6646707912770",
        product_text: "Welcome to the Christmas house. The gate is ajar and lights are on inside. Can you glimpse moments of seasonal gathering and joy through the windows? This majestic stone building is a composed sight against a background of snow-touched trees."
      },
      {
        product_name: "tweet_dreams",
        product_id: "6646709747778",
        product_text: "Illuminated by the glow of the candle, this snowman conveys such warmth in its posture and expression that it’s difficult not to melt at the sight of it. Perched upon its outstretched hand sits a bird, another having made a nest right upon this snowman’s merry head."
      },
      {
        product_name: "gingerbread_lighthouse",
        product_id: "6646710730818",
        product_text: "A gingerbread lighthouse is what childhood dreams are made of. A candy-strewn path through the snow toward the delicious-looking dwelling bypasses a towering Christmas tree, adorned with lights that could very well shine brighter than even the lighthouse’s lamp."
      },
      {
        product_name: "sweet_snowman",
        product_id: "6646712369218",
        product_text: "This sweet snowman looks overjoyed at this moment with his busy and curious companions. Several small songbirds flit around his face and body, with one even singing a merry melody perched on the tip of his carrot nose!"
      },
      {
        product_name: "new_friends",
        product_id: "6646713253954",
        product_text: "It’s Christmas at this log house as two brightly lit Christmas trees flank the stairs up to the front door. In the snow out front, there seems to be a gathering of new friends. Sweet young deer and several species of bird are enjoying the overcast day."
      },
      {
        product_name: "cosy_christmas",
        product_id: "6646718529602",
        product_text: "This cosy Christmas room conveys comfort and warmth, from the purple drapes just exposing the snowy blue hues outside to the roaring open fire. Picturesque Christmas decorations are seen everywhere – that is, everywhere that hasn’t been taken up by the adorable litter of puppies."
      },
      {
        product_name: "snowman",
        product_id: "6646720069698",
        product_text: "This snowman certainly looks pleased with his mad juggling skills, a smug grin plastered underneath his carrot nose. His delightful attire matches the mistletoe border encompassing this delightful scene. "
      },
      {
        product_name: "upon_the_night",
        product_id: "6646722297922",
        product_text: "Bows adorn the wooden fence and an elaborately lit Christmas tree to add color to this otherwise white Christmas. A brilliant full moon is suspended in the night, rising above the waters of the open ocean where a lone sailboat floats by."
      },
      {
        product_name: "winter_fence",
        product_id: "6646723412034",
        product_text: "Oh, how this winter fence honors the sweet sights and sounds of Christmas! Perched upon each post and nestled in the foliage of the partially visible wreath hanging in the wintery scene are many different species of songbird."
      },
      {
        product_name: "diamond_greeting_cards_12_pack",
        product_id: "6646724526146",
        product_text: ""
      },
      {
        product_name: "lighthouse_overlook",
        product_id: "6620559147074",
        product_text: "A pale pink sky in the horizon is an eloquent backdrop to this lighthouse overlook. Storm clouds are brewing through and the gulls are flying low around the crashing waves seen in the distance. The keeper’s cottage is swamped in an array of colour; the flowers are out and the fire seems to be gently ticking over inside."
      },
      {
        product_name: "peaceful_jaguar",
        product_id: "6620557148226",
        product_text: "A close_up portrait of this peaceful jaguar really allows us to see the fine details that make this large cat so spectacular. The depth of the jaguar’s green eyes as it rests its chin on those massive paws leaves the viewer awestruck."
      },
      {
        product_name: "spring_bunny",
        product_id: "6620534472770",
        product_text: "This spring bunny sits gently among the calming colors of the long and wandering meadow flowers. The misty setting adds an element of charm, softening the scene and bringing the small rabbit into sharper focus."
      },
      {
        product_name: "waterside_tea",
        product_id: "6620552822850",
        product_text: "A stately villa looks down over this waterside tea party that awaits on a bright and warm spring day. The fresh and clear pool of water is fed by a distant stream that bubbles over rocks as it approaches and wanders away again under a bridge and out of sight. Choice flowers from the many that have bloomed sit on a small table alongside a teapot and cups."
      },
      {
        product_name: "balcony_overlooking_vineyards",
        product_id: "6654041260098",
        product_text: "Foregoing the shade of the umbrella, a table for two has been set, ready and waiting with two glasses of wine freshly poured. Sit at this balcony overlooking the vineyards and enjoy the peaceful scene on this warm, clear day."
      },
      {
        product_name: "moon_lily",
        product_id: "6654044274754",
        product_text: "Wearing a wide-brimmed hat of moon and stars, the somewhat surprised, multicolored stare of this moon lily bores into you as you take in this curious portrait. A cat’s eyes mirror her own as it perches atop her shock of pink and blue hair."
      },
      {
        product_name: "rhapsody_in_rose",
        product_id: "6654034739266",
        product_text: "This quaint garden shed shelving is packed full of pots, watering cans, buckets, and birdhouses. It is a rhapsody in rose, with soft pinkish hues accentuating the simple innocence of this collection of objects."
      },
      {
        product_name: "il_lungolago",
        product_id: "6654022058050",
        product_text: "Here at il lungolago, the lakefront, you can walk along the flower and tree_dotted white concrete path and into the shelter of a large structure created in times past. The lake and distant hills beyond can be seen on this bright and blue sunny day."
      },
      {
        product_name: "fun_day_ahead",
        product_id: "6654009540674",
        product_text: "It certainly looks to be a fun day ahead in this design! You can see the white caps in the ocean between the two beach houses and wind-blown palm trees all around. It’s a perfect day for a spot of surfing, so it’s no surprise to see a person running toward the sea with a surfboard in hand."
      },
      {
        product_name: "mixed_bouquet",
        product_id: "6653999611970",
        product_text: "This mixed bouquet is set in a small glass vase with an assortment of summer blooms bursting out like a display of fireworks. Gently embraced by purple and red gladioli among other glorious flower heads is a striking sunflower, its black seeded face pointing directly at the viewer."
      },
      {
        product_name: "remembrance",
        product_id: "6654031822914",
        product_text: "As the sun sets on this moody day, the colors of the sky are fierce. There is fresh growth on a lone tree, symbolic of new life. Hundreds of red poppies are bursting open in a tribute of remembrance for those who are now as free as the birds we see soaring off into the sunset."
      },
      {
        product_name: "memories",
        product_id: "6654030643266",
        product_text: "The dark and brooding sky, the fading autumn colors in the trees, and the thousands of poppies spread across every piece of available land all invoke memories of a time that lest we forget. The calm waters encroached upon by the poppy-laden fields add an element of peace."
      },
      {
        product_name: "tis_the_season",
        product_id: "6654015864898",
        product_text: "‘Tis the season for magic and wonder – and don’t forget the presents! This fairy is rugged up tight against the fierce winter winds as she sits crossed-legged on the snow, hugging some gifts. Even her pet black cat is protected against the elements, adorned with a cute scarf."
      },
      {
        product_name: "snow_queen",
        product_id: "6654046961730",
        product_text: "A snow queen with a crown and collar of icicles looks down on the rest from under her eyelashes. Her white-blonde hair falls in a braid as the harsh winter winds whip and curl around the frozen forest behind her."
      },
      {
        product_name: "daffodil_bouquet",
        product_id: "6654038933570",
        product_text: "This daffodil bouquet, with bulbs and large, flaring trumpets, heralds the bright fresh days of spring. Placed in a glass vase alongside other delicate blooms indoors, one can view a clear and brilliant day through the window."
      },
      {
        product_name: "the_grand_illusion",
        product_id: "6654037917762",
        product_text: "Leaving a different impression on everyone who views it, with more to see each time you look, this grand illusion is just waiting to marvel and astound the viewer. There is a galaxy above, through clouds to waters below, as a young girl stands holding offerings of wonder."
      },
      {
        product_name: "old_winter_cottage",
        product_id: "6654006394946",
        product_text: "This old winter cottage has stood the test of time and is weathering yet another hard winter. Snow is piled thick on the thatched roof, and although ducks are swimming in the pond, it looks near-frozen over. Can you spot the children building a snowman on this crisp evening?"
      },
      {
        product_name: "autumn_oasis",
        product_id: "6654018224194",
        product_text: "The colors are just starting to turn in this autumn oasis, and there is abundance everywhere you look. A white bench with a small cushion is positioned among the many pots bursting with late summertime blooms, while pumpkins litter the surrounding areas. Butterflies, squirrels, and birds are making the most of this plentiful bounty."
      },
      {
        product_name: "la_fattoria",
        product_id: "6654024089666",
        product_text: "There is plenty of activity here at la fattoria, the farm. Vehicles from past generations are kept well maintained and tidy, and the grand farmhouse itself is a sight to behold. Farm animals are scattered around the foreground, while hot air balloons provide a pop of color in the sky."
      },
      {
        product_name: "breeze_off_the_ocean",
        product_id: "6654041882690",
        product_text: "As this white paneled window has been left ajar, you can feel the breeze off the ocean stirring life into the world outside. Small vases of flowers, a seashell, and some books litter the window sill inside, while a choppy ocean mirrors the blue sky outside, with a luscious forest scene set beyond."
      },
      {
        product_name: "blue_lagoon",
        product_id: "6654029398082",
        product_text: "Sparkling in the bright sunshine are the many cascading waterfalls that all find their way into the blue lagoon. This too shimmers and sparkles in the bright light of day, delicately contrasted by the deep pinks, purples, and greens of trees bursting into bloom at the top of the cliffs."
      },
      {
        product_name: "monastery_gardens",
        product_id: "6654011244610",
        product_text: "These monastery gardens provide some much-needed shade, as you can see that the sun is beating down on this seaside environment. In the distance, tall mountains from behind and across the water loom, giving the impression that this holy space is an oasis of diversity with its many flowering shrubs and trees."
      },
      {
        product_name: "princess_strawberry",
        product_id: "6654044799042",
        product_text: "This princess strawberry is all freckles and flounce, in nearly every hue of pink imaginable. Her piercingly bright green eyes gaze out from behind thick lashes. Her floppy hat, with its skull-shaped strawberry, and her morose cat teddy, add the slightest element of goth to this scene."
      },
      {
        product_name: "winter_angel",
        product_id: "6654004559938",
        product_text: "This winter angel is set apart from a patterned background of blue, allowing the gentle and carved_like features of its face, wings, and body to stand out. The angel has a serene and smooth face in contrast to the detail present within the rest of the image. You might notice a source of light in one hand down by the navel, while the other hand is positioned in a sign of blessing."
      },
      {
        product_name: "the_visitor",
        product_id: "6654036213826",
        product_text: "A sunbeam through this dense and magical woodland has made a spotlight on this white unicorn, which takes a drink in a sparkling pool of water fed by a many-layered waterfall. Thick green undergrowth gives way to small hints of life, whether that be the colorful wildflowers or inquisitive forest friends."
      },
      {
        product_name: "duchess",
        product_id: "6654013833282",
        product_text: "Make way, the duchess is here! With her thick, fluttering eyelashes and a fan that of course matches the rest of her ensemble, this prim and proper darling balances decorum and style with ease. No duchess is complete without a cute kitten, and you’ll find one here curled up on her lap."
      },
      {
        product_name: "orange_crush",
        product_id: "6653997973570",
        product_text: "A bouquet of flowers and foliage is placed in a rounded glass vase, complementing the main attraction of blooms that boast large, soft petals. Many other smaller daisies and lilies can be found in a variety of reds, peaches, and yellows that combine to create this gorgeous orange crush."
      },
      {
        product_name: "alice",
        product_id: "6654046437442",
        product_text: "One for the fans of Lewis Carrol, this Alice tribute has subtle nods toward many of your favorite characters set in an eerie winter woodland scene. Blue and pink contrast wonderfully here to capture both the mystery and beauty of the story."
      },
      {
        product_name: "tribal_heart",
        product_id: "6654038179906",
        product_text: "Against a trending background of large flowers, a woman stares resiliently forward as she holds a three-eyed and winged cub in her arms. Her tribal heart and tattooed form are brilliantly depicted in this moving scene."
      },
      {
        product_name: "gazebo_by_the_sea",
        product_id: "6654020321346",
        product_text: "This gazebo by the sea provides a much-needed shelter from the elements experienced on the coast. Today is a pleasant day, with a chair positioned out to enjoy the sunshine and flowers alongside the butterflies and birds. You can see a lighthouse in the distance, as well as a small yacht holding people who are clearly enjoying the beautiful day."
      },
      {
        product_name: "olive_a_taormina",
        product_id: "6654025662530",
        product_text: "A breathtaking scene of early spring blossoms cascading down white pillars frames the picturesque landscape beyond. The ancient village and Roman theater of Taormina can be seen down below, all with a spectacular vantage point of the snow-topped Mount Etna in the distance as it smokes away."
      },
      {
        product_name: "still_life_with_wines",
        product_id: "6654042603586",
        product_text: "Three very different bottles of wines, two poured out into their appropriate glasses, are scattered artfully among a varied assortment of delectable accompaniments. This is all placed on a white cloth atop a wooden table with the outdoor view in sight."
      },
      {
        product_name: "lotus_lake",
        product_id: "6654040145986",
        product_text: "Soft pinks and yellows set the tone for this calming and mystical lotus lake scene. As dragonflies and butterflies hover above the murky water, lotus flowers have fallen open, providing refuge for these gentle creatures."
      },
      {
        product_name: "endless_days",
        product_id: "6654029987906",
        product_text: "This is a sunset scene over a tranquil beach, where the gentle waves tickle at your toes and the golden sand is rivaled only by the sun still shining on these endless days. The colorful clouds are reflected in the water, creating many depths of luxurious color to soak up and enjoy."
      },
      {
        product_name: "stormy_weather",
        product_id: "6654001971266",
        product_text: "It’s stormy weather on the surface of this underwater scene, with deep, rumbling thunderheads that can be seen overhead. Under the waves, life carries on as tropical fish and coral ride the tide. A large turtle dominates the underwater space here, its captivating eye speaking volumes of wisdom."
      },
      {
        product_name: "carnival",
        product_id: "6654003806274",
        product_text: "This Venetian-style mask with its recognizable white face and richly decorated eyes is adorned by a jester’s hat, thick with bells and streamers. The whole image conveys the excited movement and color that says nothing else but carnival time!"
      },
      {
        product_name: "we_re_all_mad_here",
        product_id: "6654017896514",
        product_text: "A nod to the Alice in Wonderland marvel, an unhappy ‘Alice’ is seen glaring out through teary eyes while clinging to the Cheshire cat with its mischievous grin. “We’re all mad here” is the story being told in this scene, with skull-face flowers crowding around and a wild tattoo on this girl's arm."
      },
      {
        product_name: "blueberry",
        product_id: "6654046666818",
        product_text: "This majestic woman exudes power and importance as she gazes out with soft blue eyes. Her head is tipped slightly upward, allowing her blue hair to be swept free to one side behind her wings. This ‘Blueberry’ sits with a small creature at her shoulder as the story in your imagination begins to unfold."
      },
      {
        product_name: "morning_rush",
        product_id: "6654035787842",
        product_text: "A misty dawn breaks over towering trees and a majestic waterfall. The water flows down under an arched bridge that’s nearly engulfed by a purple creeper, all in the frenzy of the morning rush."
      },
      {
        product_name: "caribbean_cottage",
        product_id: "6654007410754",
        product_text: "This Caribbean cottage is a white-washed little home with blue detailing around the eaves and window sills. Spilling out of the white picket fence are numerous shrubs and bushes, with two palm trees stretching up toward the bright blue sky."
      },
      {
        product_name: "lost_in_the_daisies",
        product_id: "6653996335170",
        product_text: "Get lost in the daisies with this bright collection of beautiful blooms that are thickly amassed among their springtime leaves. Dark and light greens are superbly contrasted by the pinks, reds, and oranges of the daisies, with one flower in particular turned directly to face the foreground. "
      },
      {
        product_name: "japan_garden",
        product_id: "6654005641282",
        product_text: "There is something to see anywhere you look in this Japanese garden. It is bursting with color, from the bright red bridge leading you away out to the snow-tipped mountains to the colorful koi in the lily pad-filled pond. Enjoy the blossoms of spring, the details of unique Japanese architecture, and the vibrant life scattered throughout this design."
      },
      {
        product_name: "dream_landscape",
        product_id: "6654019797058",
        product_text: "This dream landscape consists of an immaculately kept cottage bordering a lively spring that gushes down a series of rocks to create a small yet impactful waterfall. Life mills around the water, where ducks, butterflies, birds, and dragonflies can be watched and enjoyed."
      },
      {
        product_name: "le_arcate",
        product_id: "6654023696450",
        product_text: "A deep, still blue lake sits below a sky thick with gray clouds that can be seen through le arcate, the arches. These arches are adorned with creepers, while many potted flowers are enjoying the cooler space made available to them out of the elements. We look out from the shade of a building, through the ornate, golden arches out to the water and trees beyond."
      },
      {
        product_name: "happy_hour",
        product_id: "6654000922690",
        product_text: "It’s happy hour for these three cheeky parrots as the sun goes down, delivering a brilliant display of color on the horizon. Perched in the branches in the foreground, these parrots seem to be investigating the numerous and colorful tropical plants that surround the scene."
      },
      {
        product_name: "sending_love",
        product_id: "6654040932418",
        product_text: "A very thoughtful card-like scene, here you can send love, and lots of it. Cartoon flowers are dotted throughout, and a large red love heart is centrally placed in the design. The colors pop against a deep blue background."
      },
      {
        product_name: "mountain_stream",
        product_id: "6654031626306",
        product_text: "The detail in this landscape, from the distant frozen mountainscape to the individual blades of grass in the meadow, set this scene above the rest. A mountain stream cascades down into the distance, through rock and forest and out to the water."
      },
      {
        product_name: "rhine_wine_moment",
        product_id: "6654043881538",
        product_text: "Seen through the frame of a traditional building window, the Rhine river weaves its way through mountainscapes into a small European village. Set on the window ledge are a clear white wine and an assortment of delicious accompaniments, making this the perfect Rhine wine moment."
      },
      {
        product_name: "repunzel",
        product_id: "6654048305218",
        product_text: "Oh my, does our Rapunzel look bored as she stares out from her tower with her head (and hair) in her hands. At least she has some company in the form of a few feathered friends, but by the look of her elaborately painted eyes, she couldn’t care less."
      },
      {
        product_name: "sugar_and_spice",
        product_id: "6654016389186",
        product_text: "It’s sugar and spice and all things nice! An abstract heart pattern in the background sets the scene for this sugar plum fairy. In a bright pink dress with puffed sleeves, she cradles a sweet of her own, with many more scattered around her as she sits up on her knees to gaze out dreamily toward the viewer."
      },
      {
        product_name: "summer_bouquet",
        product_id: "6654038638658",
        product_text: "A summer bouquet of brilliantly colored blooms towers up into the light blue sky. An intricately patterned blue morpho butterfly flitters past, drawing your eye to some abstract, transparent leaf detail toward the top of the scene."
      },
      {
        product_name: "sarah",
        product_id: "6654047453250",
        product_text: "One for the Labyrinth fans, this ode to Sarah is unmistakable to those who know the story. She holds a small Bowie doll in her hands, while her hair and dress are reminiscent of the ball attire she wore in the film. The portrait fades to a blur, with Sarah’s hair blending into the smoky background."
      },
      {
        product_name: "manor_on_the_water",
        product_id: "6654042865730",
        product_text: "A juxtaposition of curved archways and sharp, pointed lines can be seen here on this manor on the water. Half entombed by the ever-encroaching foliage, the steps to this impressive building lead right down into the water, which gently laps at all sides."
      },
      {
        product_name: "puppy_love",
        product_id: "6654014292034",
        product_text: "Is this puppy love, or love at first sight? This sweet fairy with thick blue braids is kneeling to snuggle a sweet and small puppy that looks ever so pleased with the attention. The abstract background of a floral design complements the polka dots of her dress and contrasts with the fine line detailing in her wings."
      },
      {
        product_name: "beautiful_blossoms",
        product_id: "6654019338306",
        product_text: "It must be spring, as the beautiful blossoms are bursting from every tree, bush, and plant – and what a welcome sight it is! The sky is bustling with busy birds and butterflies as the warm sun shines down in this park-like garden. A bench and wishing well are both close by, with stone steps leading you up onto more grass and toward a gazebo that stands next to a brilliant display of pink cherry tree blossoms."
      },
      {
        product_name: "a_spasso_per_venezia",
        product_id: "6654021599298",
        product_text: "If you feel like a spasso per Venezia (or in English, a walk around Venice), you’ve come to the right place. A traditional scene of tall buildings with narrow alleyways allows us to recognize the memorable cityscape, but here, we’re also treated to steps leading up to a door over the canal. Baskets litter the ground, making the moment feel more relaxed and lived-in."
      },
      {
        product_name: "country_reflections",
        product_id: "6654034247746",
        product_text: "The breathtaking tree that is the centerpiece of these country reflections stands at the gateway to a farming village, just across the stream at the water’s edge. The path looks well used and a little worse for wear, but the houses in the distance appear neat, orderly, and welcoming."
      },
      {
        product_name: "private_collection",
        product_id: "6654036770882",
        product_text: "The woman’s cold, steely sights are set upon you as she holds her rifle proudly before her private collection. Not what you might have first assumed, however – a vast selection of prized butterflies are hung on the wall. Her fox is nestled around her shoulders, looking very much alive."
      },
      {
        product_name: "provence_blue_door",
        product_id: "6654042308674",
        product_text: "This Provence blue door is a statement just as bold, in this cobblestoned courtyard and dwelling, as the tall blue wildflowers that spray like fireworks alongside. In pleasing contrast are the cascading deep red and pink blooms hanging from the balcony above."
      },
      {
        product_name: "colorful_garden",
        product_id: "6654040539202",
        product_text: "This sure is a colorful garden scene, and not only for the tall and towering summertime foxgloves and hyacinths that fade away into the distance. Perched on a white picket fence, a diverse array of boldly colored birds grace this glorious garden."
      },
      {
        product_name: "colours_of_spring",
        product_id: "6654029725762",
        product_text: "Incredible detail can be found in this soothing scene that pops with the colors of spring. A small squirrel, relishing in the warmth of the day, sits before the trunk of a tree in full bloom. As your eye wanders out over the meadow, water, and hills beyond, the energy of new life is everywhere."
      },
      {
        product_name: "forest_friends",
        product_id: "6654017142850",
        product_text: "This calming and gentle fairy is surrounded by her forest friends. A deer and a squirrel nestle in close as she curls down on a bed of meadow flowers, all purple, pink, and white. The darker, earthy color choices make the scene feel even more mysterious and wondrous."
      },
      {
        product_name: "spirit",
        product_id: "6654047780930",
        product_text: "The spirit is strong with this blue-haired witch who owns this Halloween theme. She clutches a hairless Sphynx cat, a star at its third eye, which she matches with three tattooed stars of her own under her eye."
      },
      {
        product_name: "the_road_less_traveled",
        product_id: "6654012391490",
        product_text: "It’s as if time has stopped here in this quiet seaside village. Each small summertime cottage has been well maintained and is perfectly presented with a rich array of greenery to soften the salty spray of the sea. Although clearly much loved, here is the road less traveled, with not a soul in sight."
      },
      {
        product_name: "lo_steccato_sul_fiume",
        product_id: "6654024548418",
        product_text: "A beautiful villa of grand proportions fits right into the landscape, creating a welcoming and comfortable scene. A path tightly hugged by purple and pink shrubs meanders past lo steccato sul fiume, the fence on the river, out to the autumnal forest beyond. The fires are alight inside – come on in and make yourself cozy!"
      },
      {
        product_name: "beach_days",
        product_id: "6654019076162",
        product_text: "There’s nothing like lazy beach days where the chairs are stationed high in the sand for you to watch the tide crash closer and closer to your toes. Numerous flowers to feast your eyes upon are scattered along the path down to the beach, and a spectacular lighthouse can be glimpsed out in the distance."
      },
      {
        product_name: "garden_path",
        product_id: "6654035591234",
        product_text: "Come up the garden path and you will be met by an assortment of trailing creepers, potted blooms, and wild and unkempt cottage oddities. The sun breaks through the haze and shines down through the gnarly trees and onto the white garden shed in the distance."
      },
      {
        product_name: "arctic_fox",
        product_id: "6654037688386",
        product_text: "The arctic fox that this otherworldly woman is holding looks as cute and cuddly as a teddy bear. Its large, round eyes are smiling as a kitty mask it wears sits askew. In stark contrast, with ornamental spikes coming from her elaborate hairstyle, this three-eyed woman calmly observes her surroundings."
      },
      {
        product_name: "happy_hummers",
        product_id: "6654039720002",
        product_text: "These two busy hummingbirds sure look to be happy hummers as they flit around this richly colored and diverse garden. A small, spotted white butterfly gently caresses newly-opened bluebells, while bold yellow daisies and fiery poppies and gladioli warm the scene."
      },
      {
        product_name: "smell_the_roses",
        product_id: "6653998465090",
        product_text: "Immediately, the viewer is hit by a sight of beauty so powerful that you can almost smell the roses. The blooming flowers have been captured at the moment of their perfection, open and radiating their brilliance. Little leaves can be seen as the image simply pops with purples, reds, and pinks."
      },
      {
        product_name: "sweetie_bunny",
        product_id: "6654048010306",
        product_text: "Hi there, sweetie bunny, with your candy hat and ice cream earrings! Her posture is somewhat coy as she holds a pink bunny to her body, her blue hair fanning out behind her."
      },
      {
        product_name: "barche_a_varenna",
        product_id: "6654025269314",
        product_text: "The lakeside commune of Varenna sits proudly nestled between Lake Como and the richly diverse hills that are thick with trees and growth. The barche a Varenna, the boats in Varenna, are lined up haphazardly along both the beach and village side, waiting to be of use the next day."
      },
      {
        product_name: "summer_escape",
        product_id: "6654021107778",
        product_text: "In search of a summer escape? Look no further than this scene, where you can sit on the balcony and look directly out to the sea and wash your worries away. A stroll along the beach at some other time has clearly delivered some treasures, which are placed on the table between the chairs, while many summertime blooms welcome birds and butterflies to your door."
      },
      {
        product_name: "dahlia",
        product_id: "6737048731714",
        product_text: "Dahlia and her winged sphinx cat sport matching markings that can be seen as they face one another. She is an amethyst-eyed girl with amethysts in her lime-green and pink hair, a splash of brightness against her black witch hat."
      },
      {
        product_name: "lilac",
        product_id: "6737049092162",
        product_text: "Keeping herself warm with a fur muff, stole, and jewel-adorned headpiece, this lilac-eyed beauty stands composed in this wintery scene. Snowflake patterns adorn her skin, and her hair is a striking blend of black and white."
      },
      {
        product_name: "moon_and_star",
        product_id: "6737046962242",
        product_text: "Moon and Star are twins of subtle differences. The hair of one is teal, the other purple, and they are adorned by symbols of their respective names. They both stand entwined in black clothing and sporting witch hats atop their heads."
      },
      {
        product_name: "daydreamer",
        product_id: "6737047912514",
        product_text: "Head and shoulders above the waters, this mermaid daydreamer contemplates what she sees. Her long, pointed fingers are held against her sparkling face, and orcas complete this fantasy scene."
      },
      {
        product_name: "venice_terrace",
        product_id: "6737014947906",
        product_text: "This Venetian terrace view looks out over the calm and still canal waters, where several gondolas bob gently against the flower-laden paths and patios. Just a stone wall away laps the wide ocean expanse, the sun setting in the distance."
      },
      {
        product_name: "we_re_alright",
        product_id: "6737017798722",
        product_text: "A moving image of motherly protection that can be spoken and understood in any language. A mother bear embraces her young cub in a foreboding forest setting. As they sit together, you can almost hear her saying, “We’re alright.”"
      },
      {
        product_name: "biological_key",
        product_id: "6737048305730",
        product_text: "Nude makeup softens this beauty’s face, her blonde hair electrified like lightning against the stormy night backdrop. She sits with a swan, a locket around its neck, while she holds the biological key in her hand."
      },
      {
        product_name: "blanca",
        product_id: "6737047158850",
        product_text: "Blanca holds a phone to her ear while her mesmerizing eyes stare straight into the depths of your soul. Her white hair cascades down to her hips, past a black cat perched on her shoulder that sports a star on its forehead."
      },
      {
        product_name: "aries",
        product_id: "6738568937538",
        product_text: "Aries, her hair in the shape of horns, wears a dress that mirrors this arrangement. The motif, seen as the amulet she wears, appears everywhere you look, while sheep perch as flowers among the leaves in the background."
      },
      {
        product_name: "taurus",
        product_id: "6738572345410",
        product_text: "Taurus is both strong and delicate. Her bull-horned crown is held strong, yet she wears a soft poppy-pink dress. The leafless trees behind her contrast with her soft brown curls and fur cape."
      },
      {
        product_name: "gemini",
        product_id: "6738569953346",
        product_text: "The twins represent day and night, their hair connecting them, as one is upside down. The Gemini symbol is seen on both of their arms and as a crown."
      },
      {
        product_name: "cancer",
        product_id: "6738569101378",
        product_text: "Cancer sits at the beach, her symbolic crab sitting alongside her before a castle of sand. She wears a crab shell dress, the pinchers like a cape over her shoulders and shells as a collar."
      },
      {
        product_name: "scorpio",
        product_id: "6738571821122",
        product_text: "As lightning strikes and rain falls, Scorpio looks over her shoulder and offers a small smile. Holding a scorpion in her hand and wearing her auburn locks in a similar fashion, this woman can clearly sting."
      },
      {
        product_name: "libra",
        product_id: "6738570838082",
        product_text: "Libra stands with her hands on her hips, her hair in divided yet unified plaits, balancing a crown of scales on her head. Wearing a royal blue dress and with a lizard perched on her shoulder, her piercing eyes look fair in every way."
      },
      {
        product_name: "virgo",
        product_id: "6738572771394",
        product_text: "Virgo stands with long flowing locks against a myriad of swirls and curling flowers. Her hazel eyes are the same color as the pendant around her neck, and she wears a soft dress of pink that matches the sunset."
      },
      {
        product_name: "leo",
        product_id: "6738570313794",
        product_text: "Leo, our freckled lion with a mane of fire, stands among sunflowers with a cub by her side. She wears a simple crown, a collar of leaves, and a symbolic pendant around her neck."
      },
      {
        product_name: "shadow alice",
        product_id: "6737047552066",
        product_text: "Shadow Alice, with her Cheshire cat bag, holds a skull and crossbones teacup in her hands. From her artfully ripped attire to her one button-eyed bunny, everything about this wonderland beauty is anything but proper."
      },
  	  {
        product_name: "Peppermint",
        product_id: "6737049157698",
        product_text: "A peppermint crown of spikes and thorns sits atop this figure’s winter-white hair. Ice-blue eyes look out from underneath incredibly long lashes as she sits poised in a stunning gown."
      },
  	  {
        product_name: "Rock Island Lighthouse",
        product_id: "6737015341122",
        product_text: "A sunset lights up this scene like fire. As the playful ocean sparkles and trees are bathed in gold, the proud American Rock Island lighthouse stands tall and strong. Its light is already shining as numerous flocks of seabirds are seen heading in for the evening."
      },
      {
        product_name: "Coastal Living",
        product_id: "6737017307202",
        product_text: "If you are enticed by coastal living, this peaceful village is all you could wish for. In the cool light of dawn, a path can be seen leading down to the lively water’s edge. This is surrounded by tidy homes with neat gardens, all exuding life and warmth from behind their windows."
      },
      {
        product_name: "Como Sunset",
        product_id: "6737015177282",
        product_text: "This Como sunset of blues and pinks begins to cast shadows on the seaside township. The warm glow from a restaurant beckons, steps leading directly from the water’s edge to colorful boats that rest anchored to the shore."
      },
      {
        product_name: "Horse Valley Farm",
        product_id: "6737016913986",
        product_text: "You have arrived at Horse Valley Farm. Two sleek and shining horses canter up to a fence bordering the road to meet you. Look past the show of autumnal colors to the classic big red barn, the farmhouse, and beyond, where the rolling hills stretch up into a moody sky."
      },  
      {
        product_name: "Crimson",
        product_id: "6737048830018",
        product_text: "A wintery background sets the scene for this regal sweetheart. Her crimson lips, blush-pink cheeks, and flaming eyes are complemented by her red and black attire and jewels."
      },  
      {
        product_name: "Miss Macaroon",
        product_id: "6737048666178",
        product_text: "Miss Macaroon is an ethereal creature, combining food and fantasy to create a stunning visual piece. As a mermaid, she floats close to her ocean-born pet, yet adorning her body and hair that cascades around her are the flavorsome French delicacy, macaroons."
      },
      {
        product_name: "Sagittarius",
        product_id: "6738571493442",
        product_text: "Sagittarius sports a quiver and bow at her back, wearing warrior clothing and fur at her shoulders. Crisp, autumn oak leaves wind around behind her against a fierce sunset."
      },
      {
        product_name: "Capricorn",
        product_id: "6738569658434",
        product_text: "Capricorn curls in close to a friendly-looking goat with the tail of a mermaid. Ivy and pansies decorate this starry night scene, and the blonde-haired woman wears a symbolic crown."
      },
      {
        product_name: "Aquarius",
        product_id: "6738568478786",
        product_text: "Aquarius sits pouring water from a vessel, gazing knowingly at her viewers. She sports a drop-bejeweled vest as orchids and birds surround her. Mysterious symbols can be seen on her arm."
      },
      {
        product_name: "Pisces",
        product_id: "6738571264066",
        product_text: "Pisces looks freshly pulled from the water, her curls hanging wet among the bubble-like jewels. Fish swim around her head and the water beckons in the background, a beautiful lily sitting atop the blue."
      },
      {
        product_name: "Love Song",
        product_id: "6737049452610",
        product_text: "With sugar skull makeup and skeleton paint designs over her arms and legs, this young rocker plays a love song on her guitar that we might all know the tune to. Her crown of soft lilies and sharp thorns and spikes complete her look."
      },
      {
        product_name: "The Twins",
        product_id: "6737047453762",
        product_text: "The twins stand, mirroring one another in their bedroom. One holds a bear, the other a bunny, but both animals are oozing stuffing and stare with lost eyes. Their expressionless faces give more life to their knowing eyes that you cannot look away from."
      },
      {
        product_name: "Cottage Way Lane",
        product_id: "6737015701570",
        product_text: "A black and white cat sits on the cottage way lane, glancing toward a pair of swans that glide along serenely in a natural pond. A thatched roof cottage is half-swallowed by the encroaching shrubbery, looking comfortable and inviting as it sees out the passing years."
      },
      {
        product_name: "Sunset Serenity",
        product_id: "6737017241666",
        product_text: "A roaring campfire mimics the colors of this sunset serenity as the sun dips below the grasses beyond the water. A well-built cabin sits in quiet solitude, staving off the cool air of the autumn dusk."
      },
      {
        product_name: "Mountain Village",
        product_id: "6737017995330",
        product_text: "Ducks fly overhead, scarcely seen amid the smoke and mist that has settled in the air of this mountain village. With the setting sun and encroaching cool, fires are stoked within the homes and the village boats are left tied up and unmanned in the water."
      },
      {
        product_name: "Silent Night",
        product_id: "6737017634882",
        product_text: "Horses and carriages wait calmly in the fallen snow for those in the humble church to exit. As a train rolls by, a full moon shines above, encompassed by the beautiful show of the northern lights. This silent night scene exudes a feeling of calm and peaceful season’s greetings."
      },
      {
        product_name: "Jessie",
        product_id: "6737047289922",
        product_text: "Jessie is young and vibrant, her green and purple hair spraying out and over her shoulders, where a purple and green-eyed cat perches. Headphones on her ears that are connected to a tape deck, Jessie also sports a quirky pumpkin skull bag in matching colors."
      },
      {
        product_name: "Never Leave Home",
        product_id: "6737048109122",
        product_text: "This mesmerizing beauty tells two tales: one of soft, innocent pinks and the other of sultry black. Her candy-pink hair and matching bow frame her figure, which is enrobed in black lace. As she applies black lipstick, she admires the tattoos on her neck."
      },
      {
        product_name: "Summer Celebration",
        product_id: "6766589902914",
        product_text: "Oooh, Aaah. A summer celebration of American independence is in full swing as fireworks light up the night sky. Butterflies and fireflies flit around the warm air of the cottage garden, where a log cabin stands on the edge of a small lake."
      },
      {
        product_name: "Fourth Friends",
        product_id: "6766592950338",
        product_text: "Patriotism shows no boundaries as evening celebrations are enjoyed by these ‘Fourth friends’. A small child dressed in red, white and blue holds a sparkler as she stands with her golden cat and dog companions, admiring the fireworks in the distance."
      },
      {
        product_name: "Blooming Backyard",
        product_id: "6766587904066",
        product_text: "This blooming backyard is well kept and vast. Neat lawns are surrounded by ornamental shrubs, a flowing fountain, and delicate spring flowers that have burst open, to the delight of many butterflies and birds."
      },
      {
        product_name: "Nature Haven",
        product_id: "6766589542466",
        product_text: "Do you desire an escape to the wilderness? This nature haven welcomes you. Blossoms pop all around the traditional log cabin, and as you look out to the sharp peaks of a mountain top in the distance, an eagle flies overhead."
      },
      {
        product_name: "Happiness Ice Cream Shop",
        product_id: "6766593507394",
        product_text: "Welcome to the Happiness Ice Cream shop, where every day is ‘sundae!’ A young girl sits out in front of the shop’s signage, sharing her ice cream cone with a piglet. Kittens peek out of the basket on her small bike, and happiness can be seen all around."
      },
      {
        product_name: "Thinking of You",
        product_id: "6766590722114",
        product_text: "Two girls have been thinking of you and stand waiting at a red door with flowers hidden behind their backs. Vases and planters are brimming with blooms of all kinds, and a kitten is curled up asleep in the dappled shade of the porch."
      },
      {
        product_name: "Floral Fantasy",
        product_id: "6766588133442",
        product_text: "A small wooden gazebo overlooks a lone swan that drifts calmly along a peaceful lake. Before it lies a floral fantasy of potted and planted spring bulbs and blossoms. Take a seat, pick up a book, and dream the day away."
      },  
      {
        product_name: "Lakeside Retreat",
        product_id: "6766589345858",
        product_text: "Welcome to your lakeside retreat, where a quaint log cabin rests nestled among an explosion of color and life. A yacht can be seen bobbling along the rippling water that lies behind the house, set before a rolling hill of green forest."
      },
      {
        product_name: "Happy Birthday",
        product_id: "6766591213634",
        product_text: "In the windows of the ‘Happy Birthday shop,’ cakes, presents, and all things party can be seen. A gaggle of children, puppies, and kittens crowd the pavement outside, staring adoringly in at the scenes of delight."
      },
      {
        product_name: "Stop and Smell the Roses",
        product_id: "6766591082562",
        product_text: "On her way out the gate from her quaint cottage home, a small girl takes the time to stop and smell the roses. A welcoming archway is covered with purple wisteria, and many other blooms can be seen leading up the pathway."
      },
      {
        product_name: "Mystery Kit #1",
        product_id: "6766590132290",
        product_text: "The muted sky is kindred to the stately and traditional house yet opposes the brilliant displays of color in this lakeside garden setting. Birds and butterflies all prepare for their twilight flight as the lights come on inside."
      },
      {
        product_name: "Mystery Kit #2",
        product_id: "6766592622658",
        product_text: "Two young sisters hold hands outside a girl’s clothing store named ‘My Sister’s Closet.’ A kitten sits before a sign, and looking at the shopping bags next to the girls, what it says is true: a girl can never have too many shoes!"
      },
      {
        product_name: "Autumn Well Wishes",
        product_id: "6766587543618",
        product_text: "A black cat sits at the window of a large house made of stone and wooden shingles. The bright blue autumn sky is teeming with birds  and butterflies as leaves  turn to red and yellow all around."
      },
      {
        product_name: "Tea for Two",
        product_id: "6766593376322",
        product_text: "Two beautifully dressed young girls chink their cups as they sit down for tea for two. The pink flowers on their hats match both those creeping over a fence and their small table and chairs. Teddy has been invited, as has a dog and a cat that sit dutifully alongside."
      },
      {
        product_name: "Harvest Moon",
        product_id: "6766588887106",
        product_text: "The harvest moon hangs full in the night sky, casting a bright light onto the farmyard scene below. A large red barn complements the deep hues of autumn in the trees, and a scarecrow beams merrily from a lantern pole."
      },
      {
        product_name: "The Doctor is in",
        product_id: "6766592163906",
        product_text: "Out in the garden and among the flowers lies the hugs and kisses ambulance. The doctor is in and tending to a puppy. His assistant is ready with bandages while the next patient, a kitten, awaits her turn."
      },
      {
        product_name: "Castle of Dreams",
        product_id: "6799283880002",
        product_text: "A Saint Bernard stands before a small arch bridge that leads the way over a swan-filled lake. Beyond this and rising from the ground like the mountains behind it is a castle of dreams. Spires, embrasures, crenellations, even a glasshouse – this castle has it all."
      },
      {
        product_name: "A New Day",
        product_id: "6799288041538",
        product_text: "Delicate violas jostle for space in this dreamy close-up scene. The feathery brush strokes add a multidimensional touch to the petals and leaves."
      },
      {
        product_name: "Reflection",
        product_id: "6799290204226",
        product_text: "Neon pink, burnt orange, and canary yellow all burst from the limbs of trees in this dense forest, the reflection of it all seen in the gently stirred waters of a lake lying between them."
      },
      {
        product_name: "Cutest of Them All",
        product_id: "6799293743170",
        product_text: "A white cat with blue eyes sits low with its feet hanging over a ledge. The deep blue fabric it sits on looks as soft as its fur. This purebred charmer has to be the cutest of them all."
      },
      {
        product_name: "Autumn Wolf Family",
        product_id: "6799306686530",
        product_text: "This autumn wolf family is a sight to behold. Four small pups sit with two adults, their fur shining as the setting sun casts a soft light on the picturesque forest setting."
      },
      {
        product_name: "Tarot Town",
        product_id: "6799334211650",
        product_text: "Suspended in mid-air, Tarot Town is a magical fantasy full of symbolism and wonder. A castle sits under the arch of a rainbow that cuts through a wheel of constellations, fish pulling boats through the sky."
      },
      {
        product_name: "Mutiny",
        product_id: "6799347220546",
        product_text: "This pirate girl has mutiny on her mind as she stands with her eyes narrowed, arms crossed and a dagger in hand. The scar across her cheek hints that she isn’t someone you want to cross."
      },
      {
        product_name: "Loving Zebras",
        product_id: "6799364751426",
        product_text: "Two loving zebras stand with their heads together as behind them, the herd busies itself with eating and drinking. This grassland scene is rich in life, with birds in the air and trees growing tall."
      },
      {
        product_name: "Bride of Frankenstein",
        product_id: "6799368486978",
        product_text: "The bride of Frankenstein strikes an elegant pose, a lace-edged Bardot collar curling up around her patchwork-stitched skin. A shock of white hair streaks through the black, which cascades upward."
      },
      {
        product_name: "Eternal",
        product_id: "6799368880194",
        product_text: "From one peaceful pond, a small, delicate waterfall feeds another. Separating the two bodies of water stands a tree, thick with blossoms of neon pink. In the distance, an eternal light glows bright and warm."
      },
      {
        product_name: "Daisy Meadow",
        product_id: "6799369961538",
        product_text: "The yellow orbs surrounded by petals of white are intermingled with splashes of color from other field flowers in this daisy meadow. Hues of purple and dark blue in the sky make the blooms pop that much more."
      },
      {
        product_name: "Playing with Fire",
        product_id: "6799370715202",
        product_text: "This blue-eyed Wiccan beauty is playing with fire with candles perched atop her pointed hat. A similarly blue-eyed black cat swings from her arm, and yet another eye hangs from her neck."
      },
      {
        product_name: "Pumpkin Time",
        product_id: "6766590787650",
        product_text: "It’s pumpkin time at the great pumpkin festival. Held at the country store, children can be seen inside bobbing for apples, while others peek through the window at the abundance of candy apples on display. Outside, fallen leaves cover the ground, and of course, there are pumpkins galore!"
      },
      {
        product_name: "Scary Hall",
        product_id: "6799372812354",
        product_text: "Heed the signs and get away from this scary hall. The wrought-iron gates are ajar, and rats and spiders creep around the entrance. Although the lights are glowing from inside this villa, it appears that only ghosts and other terrors remain."
      },
      {
        product_name: "Sombra",
        product_id: "6799377236034",
        product_text: "With her collar of calla lilies and a scowling owl perched on her shoulder, Sombra is a vision of elegant despair. Holding a single candle in front of her, her calavera makeup speaks of her purpose."
      },
      {
        product_name: "Pumpkins for Sale",
        product_id: "6799373795394",
        product_text: "Pumpkins for sale are stacked so high that they reach the tip of an autumnally-dressed gnome. His oversized button nose hides two soft brown eyes as he stands next to his fair crop."
      },
      {
        product_name: "Luella’s Halloween",
        product_id: "6799374417986",
        product_text: "A brightly lit treehouse home is a beacon for these wild trick-or-treaters. Luella’s Halloween is all she ever wanted, the princess mouse holding her candy bag next to her Superman squirrel friend."
      },
      {
        product_name: "Halloween Kittens",
        product_id: "6799378219074",
        product_text: "These three Halloween kittens are dressed up and ready for their treats. A little ginger wizard meows, while a black and white pirate is perched atop a carved pumpkin. Can you see the third kitten peeking out from the pumpkin’s smile?"
      },
      {
        product_name: "Viridescent",
        product_id: "6799376252994",
        product_text: "This strawberry blonde enchantress oozes a formidable power. Her hat holds bottles of potions and viridescent spines, and the same viridescent color diffuses from her eyes and streaks through her braided hair. A small green-eyed and scruffy cat perches on her shoulder."
      },
      {
        product_name: "Elvanna and Cinder",
        product_id: "6807236640834",
        product_text: "With her long hair in a side-swept braid underneath a crumpled witch’s hat, Elvanna and Cinder, her black cat, stand together against a backdrop of a city at night. Three Halloween pumpkins add to the autumnal decor."
      },
      {
        product_name: "Witchy Halloween",
        product_id: "6807248961602",
        product_text: "This cute, witchy Halloween dragon has sparkles in its eyes underneath a pointed hat. Curled up inside a pumpkin that is steaming green, there are symbols of both trick and treat in this Halloween scene."
      },
      {
        product_name: "Witch Broom Shop",
        product_id: "6766593179714",
        product_text: "Little witches line up outside the witch broom shop, looking at the array of magical wares on display. The hauntingly spooky colors of purple and bright green dominate the scene, with Halloween pumpkin orange splashed throughout."
      },
      {
        product_name: "Mariposa",
        product_id: "6807264919618",
        product_text: "Mariposa is about to take flight with her butterfly wings and hair clips. Dressed in a skeletal slip and donning traditional Los Muertos makeup, is this her dream or a nightmare?"
      },
      {
        product_name: "Halloween Cupcake",
        product_id: "6807288348738",
        product_text: "The two cartoon ghosts that flank this perfectly presented Halloween cupcake show what we are all thinking: Oooh! Adorned with all the classic creepy tokens, this delicious treat is finished with a perfect black bow."
      },
      {
        product_name: "Halloween Night in the Pumpkins",
        product_id: "6807303880770",
        product_text: "As the bare arms of a tree reach up toward a vibrant galaxy swirling in the night sky, you prepare for your Halloween night in the pumpkins. A relaxed-looking skeleton sits atop an iconic Volkswagen Beetle, which is surrounded by carved and cropped pumpkins."
      },
      {
        product_name: "Indigo",
        product_id: "6807274651714",
        product_text: "Both Indigo and her black cat have the same distinctive eye quirk, the moody colors throwing a ghostly hue onto her skin. Between her pointed witch hat to the skull she rests her arm on, star and moon symbolism can be seen."
      },
      {
        product_name: "Cool Cat",
        product_id: "6807316299842",
        product_text: "Check out this cool cat in his oversized orange glasses; oh, how they bring out his eyes! This headshot shows hints of a blue jumper underneath a matching scarf, complementing this cat’s dark gray fur."
      },
      {
        product_name: "Neon Capital Vegas",
        product_id: "6807325999170",
        product_text: "From a penthouse balcony, complete with a pool, the view of the neon capital of Vegas is a sight to behold. The shimmering lights and glowing fountains set against the fading daylight spark one’s imagination for the night to come."
      },
      {
        product_name: "Remember When",
        product_id: "6807345987650",
        product_text: "Remember when there was a single gas and grocery store that stood at the edge of the lake? Remember dirt roads, lemonade stands, and fishing off the pier? This is a glimpse back to simpler times."
      },
      {
        product_name: "Sabine and Joy",
        product_id: "6807351853122",
        product_text: "Sabine and Joy are both puff and fluff – one with curls piled high on her head, the hoop skirt of her Victorian dress matching the color of the roses, the other a fluffy poodle sitting upon her throne."
      },
      {
        product_name: "Alice’s World",
        product_id: "6819678683202",
        product_text: "Welcome to Alice’s world, where broken hearts, playing cards, and pots of tea fly around the girl’s head as she stands composed and sure. One bright blue eye gazes ahead as she holds a striped cup, a white rabbit perched on her shoulder."
      },
      {
        product_name: "Red Riding Rasta",
        product_id: "6819678847042",
        product_text: "It's a little red riding hood, Rasta-style. Her multi-colored locks are hidden behind a swathe of red fabric. Her hand comes up to pull a piece of it aside, revealing floral arm tattoos and a pair of large, kind eyes."
      },
      {
        product_name: "Shining Grace",
        product_id: "6819678912578",
        product_text: "A soft, glowing light radiates from behind this shining grace of a woman, her soft gray eyes and heart-shaped face surrounded by bright butterflies and beautiful blooms."
      },
      {
        product_name: "Goddess in Green",
        product_id: "6819679240258",
        product_text: "A goddess in green stands with roses in her hands in an elegant emerald dress. The same roses are made into a headdress, accentuating her heart-shaped face."
      },
      {
        product_name: "Rabbit in Red",
        product_id: "6819680124994",
        product_text: "She is a rabbit in red, her ears poking out through her shock of knee-length blonde hair. She is dressed in red and a checkerboard corset, a chess piece tied into her hair."
      },
      {
        product_name: "Regal Feline",
        product_id: "6819679371330",
        product_text: "This is a male lion, his hooded yellow eyes piercing the dusty savanna that his coat blends in so perfectly with. The headshot of this regal feline is truly breathtaking."
      },
      {
        product_name: "Summer Night",
        product_id: "6819679469634",
        product_text: "All manner of wildlife sits nestled among a brilliant display of flowers in this summer night scene. From fox and fawn to bunny and bee, there is something to treasure everywhere you look."
      },
      {
        product_name: "Late Summer",
        product_id: "6819679502402",
        product_text: "It’s late summer, and the blossoms in this bouquet hold the warmth of the sun in their petals. Pinks, yellows, and earthy oranges are complemented by the rich green of their leaves."
      },
      {
        product_name: "Beyond The Sunrise",
        product_id: "6819679633474",
        product_text: "Look over the water’s edge, past the three naked, wintering trees to beyond the sunrise. Hazy blues and purples are set in an ice-cold scene, while the rising sun attempts to break through the multicolored mist."
      },
      {
        product_name: "Farmers' Market",
        product_id: "6819680026690",
        product_text: "The farmers’ market is open. Fresh fruit and flower stalls line a paved street that leads to a large, pinstriped open top. A few people peruse the offerings as balloons, both large and small, decorate the sky."
      },
      {
        product_name: "Backyard Retreat",
        product_id: "6819680092226",
        product_text: "The fire is roaring in the pit and the drinks are served. Welcome to your backyard retreat, a peaceful courtyard adorned with numerous blooms and birdlife."
      },
      {
        product_name: "Victoria Christmas Village",
        product_id: "6819680813122",
        product_text: "Horse-drawn carriages and people singing carols in front of a Christmas tree are enjoying this sunny, winter day in a Victorian Christmas village. Tall buildings line the streets that are lit and decorated for the season."
      },
      {
        product_name: "Come On In",
        product_id: "6819680944194",
        product_text: "A close-up of a townhouse’s front door is festively and elaborately decorated in tasteful checkerboard and pinstripe trimmings. Although a toy guard stands at the red door, the presents lining the steps say, “Come on in!”"
      },
      {
        product_name: "A Golden Christmas",
        product_id: "6766592426050",
        product_text: "A small boy lifts the lid on one special present that is sure to make this a Christmas to remember. Out pops a puppy, its golden fur shining like all the other gifts and ornaments that adorn this festive scene."
      },
      {
        product_name: "Cozy Christmas Evening",
        product_id: "6819683369026",
        product_text: "It’s a cozy Christmas evening – the stockings are hung in front of a roaring fire, the cat is snoozing on its favorite chair, and the presents are all stacked neatly underneath the tree."
      },
      {
        product_name: "Christmas Cindy",
        product_id: "6819683926082",
        product_text: "This blue-eyed elven cutie has earmuffs with a headband of candy and a cat a curious color of green. The vibrant festive colors of red, green, and white are playful and fun."
      },
      {
        product_name: "Suzy Snowflake",
        product_id: "6819684253762",
        product_text: "Suzy Snowflake’s dress melts into the snow, making this winged beauty appear as if she rises out from the cold. Her lilac hair cascades down to reach the two small snowfolk that huddle at her legs."
      },
      {
        product_name: "Checking His List",
        product_id: "6819684450370",
        product_text: "Santa stands in a festive living room, the fire sparkling and the trees aglow. With a candy cane in his pocket and a quill in his hand, he is checking his list of good kids, as he knows who is naughty or nice."
      },
      {
        product_name: "Festive Lantern",
        product_id: "6819684778050",
        product_text: "A festive lantern keeps a lit candle safe from winter’s cold breath. A glow of warmth against a backdrop of night blue and snow, two birds perch among it and the decorative poinsettia and mistletoe."
      },
      {
        product_name: "Christmas Eve Dreams",
        product_id: "6766592852034",
        product_text: "With milk and cookies having sent this young man off on Christmas Eve dreams, his loyal friend watches by his side. With a teddy bear in arm and the sparkle of lights on the tree, this dreamer will soon awake to the presents by his side."
      },
      {
        product_name: "Feeling Festive",
        product_id: "6819686023234",
        product_text: "You can’t help but start feeling festive when you lay your eyes on this laden Christmas tree. No branch is bare as ornaments of all colors jostle for space. Gifts spill out from underneath the tree and onto the rug and chair."
      },
      {
        product_name: "Happy Holidays",
        product_id: "6819687891010",
        product_text: "Delicate detailing adds character to these snow and light-laced trees. Reindeer reflections stand in the woods, a wreath hangs on a lighthouse window, and Santa’s sleigh can be seen riding through the moonlight."
      },
      {
        product_name: "Christmas Village Glow",
        product_id: "6819688153154",
        product_text: "The people are out and about this wintery eve, the snow is falling, and warm lights in the buildings proffer a Christmas village glow. Flocking toward the church in the distance, one man drags a Christmas tree while another rides in his very own horse-drawn carriage."
      },
      {
        product_name: "Dragon and Fairy Swing",
        product_id: "6819688841282",
        product_text: "Swinging from a chain of flowers, a fairy with prismatic wings smiles into the light and looks to not have a care in the world. Behind her, a dragon, its mouth bursting with fire, crawls closer."
      },
      {
        product_name: "Berry Sweet",
        product_id: "6819689070658",
        product_text: "With her freckles and auburn locks, this hazel-eyed darling, dressed in strawberry pink, is just so berry sweet. A plush toy cat draped over her arm completes her innocent look as she stands among the strawberry fields."
      },
      {
        product_name: "Golden Sun",
        product_id: "6819689300034",
        product_text: "A large sunflower in a bouquet has opened fully, looking much like the golden sun as its petals radiate outward. Other gracefully-colored blooms add to the warmth this flower gives."
      },
      {
        product_name: "The Hum of Summer",
        product_id: "6819690315842",
        product_text: "The hum of summer, as dragonflies and bees buzz about, making the most of the last rays of warm sun, is enjoyed by a small rabbit that sits in front of a pond and takes in its surroundings."
      },
      {
        product_name: "Traditional Charms",
        product_id: "6819689463874",
        product_text: "A South American beauty showcases some traditional charms, wearing an impressive head wrap, adorned in roses, and holding a cup of yerba mate to her lips."
      },
      {
        product_name: "Happy Hippiewagon",
        product_id: "6819689726018",
        product_text: "This ‘64 VW Beetle is the ultimate happy hippiewagon. Set against a backdrop of floral mandala patterns, this radical rainbow ride is a picture of color."
      },
      {
        product_name: "Hummingbird and Butterfly",
        product_id: "6819689922626",
        product_text: "The hummingbird and butterfly dance between the foxgloves and hydrangeas. Three of each can be seen against the bright blue sky."
      },
      {
        product_name: "Bringing Home the Christmas Tree",
        product_id: "6819691167810",
        product_text: "A red pickup is bringing home the Christmas tree on a snowy winter’s afternoon. Many houses along the lane have decorated trees adorning their front yards, one also with two snowmen smiling their pebbled smiles."
      },
      {
        product_name: "Snowman with Gold and Silver Presents",
        product_id: "6819693396034",
        product_text: "This adorably cute snowman with gold and silver presents is all wrapped up in a red striped hat and scarf underneath an elegantly decorated Christmas tree."
      },
      {
        product_name: "Patriotic Christmas",
        product_id: "6819690971202",
        product_text: "Birds of several species all dine together on some seed that has been kindly left out in this birdfeeder. Boldly painted with stars and stripes and decorated with a Christmas wreath, this is a patriotic Christmas."
      },
      {
        product_name: "Birthday Snowman",
        product_id: "6766593409090",
        product_text: "A young girl holds a cupcake and candle in her hands as she kneels down to a birthday snowman. With balloons tied to its stick arms and the horn sticking out of its mouth, its smile is matched only by the small crowned dog at its side."
      },
      {
        product_name: "Doe",
        product_id: "6819691626562",
        product_text: "A red jay sits upon antlers that emerge from her ribbons of red hair, where two bells are fixed by a bow. This doe stands with her fingers wrapped around a ribbon, from which a bell swings."
      },
      {
        product_name: "Happy Christmas",
        product_id: "6819691823170",
        product_text: "The cotton candy-colored house and decorations make this snowy winter sight a warm and inviting happy Christmas. The setting sun adds to the pink-tinged scene in which festive lights adorn everything."
      },
      {
        product_name: "Christmas Eve",
        product_id: "6819692445762",
        product_text: "It’s Christmas Eve, and Santa has crept into the living room, his sack full of presents spilling open for yearning eyes to peep. A tree, peppered with candy canes and bows, has many surprises beneath it, including a teddy on a rocking horse."
      },
      {
        product_name: "Golfer's Paradise",
        product_id: "6819679305794",
        product_text: "Long shadows drape over an immaculate lawn that rolls up toward a stunning villa in the distance. This golfer’s paradise also features a stone arch bridge that leads over a pond, burgeoning gardens, and wildlife aplenty."
      },
      {
        product_name: "Sammy’s Summer Day",
        product_id: "6819680223298",
        product_text: "As the sun rises on the horizon, Sammy’s summer day in the meadow of flowers, where a peaceful pond and barren barn sit, has begun. This little goat looks eager to play, while two others graze in the distance."
      },
      {
        product_name: "Santa has Arrived",
        product_id: "6819691429954",
        product_text: "Santa has arrived, and he’s filling the stockings that were hung in front of the roaring fire under the watchful eye of a gray house cat."
      },
      {
        product_name: "Strange Dreams",
        product_id: "6819680682050",
        product_text: "This young girl, holding her patchwork cat, is having some strange dreams. Giant candy canes, cupcakes with faces, and several skulls all dance on a bed of clouds."
      },
      {
        product_name: "Unicorn Waterfall",
        product_id: "6819680354370",
        product_text: "Splashing in the shoals, making the water sparkle in the setting sun, is a unicorn mother and her foal. A waterfall cascades into the sea and across the water, while a castle stands high and dry."
      },
      {
        product_name: "Season of Love",
        product_id: "6766591770690",
        product_text: "It is the season of love, and snow lines the streets outside the toy store. Children are feasting their eyes on the delights inside while others make snow angels, pull each other on sleds, and make snowmen. Can you spot the festive pair on the doorstep?"
      },
      {
        product_name: "Orca Fun",
        product_id: "6819680616514",
        product_text: "Join the orca fun in this colorful underwater sea. Brimming with everything from coral and turtles to schools of fish, there’s something to see wherever you look."
      },
      {
        product_name: "Peaceful Tie Dye",
        product_id: "6819680256066",
        product_text: "The scales of this wide-eyed baby dragon are a kaleidoscope of pastel colors set against a backdrop of peaceful tie-dye patterns."
      },
      {
        product_name: "Ho Ho Ho",
        product_id: "6819692118082",
        product_text: "A close-up of a Christmas tea party, complete with cupcakes and cookies, is set against the backdrop of a cutely decorated Christmas tree. The words “Ho Ho Ho” can be seen as one of the many ornaments."
      },
      {
        product_name: "Wrapped with Love",
        product_id: "6766593278018",
        product_text: "In front of the Christmas tree, gifts are being wrapped with love by a pair of small hands. Two mischievous kittens are pretending to help the golden-haired girl as she works on tying a bow around a wrapped box."
      },
      {
        product_name: "A Magical View to Christmas",
        product_id: "6819692675138",
        product_text: "Full of bright, festive lights and presents piled high, this surely is a magical view of Christmas. Penguins march on the snow outside as a puppy is curled up by the roaring fire inside. There is warmth everywhere despite the blanket of snow."
      },
      {
        product_name: "Trip to the Toy Shop",
        product_id: "6819692838978",
        product_text: "In this trip to the toy shop, there’s more fun to be had outside in this Christmas scene. Loaded in the back of a red pickup parked out front are dozens of dogs wearing Christmas hats. Catch the kittens in the Christmas tree and the basket of puppies in the snow."
      },
      {
        product_name: "Christmas Gnome and Friends",
        product_id: "6819693101122",
        product_text: "This Christmas gnome and friends stand behind a presentation of gifts, from presents stacked high to candy canes and sweets. Smiling sweetly, these three friends emanate an air of gentle kindness and love."
      },
      {
        product_name: "Sweet Candy Apple",
        product_id: "6850029387842",
        product_text: "A modern-day Snow White stands before the magic mirror on the wall, holding a sweet candy apple and wearing a Rolling Stones t-shirt. The hats of the seven dwarfs can be seen surrounding her."
      },
      {
        product_name: "Starlight",
        product_id: "6850030075970",
        product_text: "With her waves of blue and purple hair and a panda bear earring dangling above her painted shoulder, Starlight poses in an off-the-shoulder top, her burgundy eyes the same color as her lips."
      },
      {
        product_name: "Autumn’s Gift",
        product_id: "6850029518914",
        product_text: "Wild meadow flowers bloom abundantly on the banks of a meandering lake, autumn’s gift offering a variety of deep crimsons and golds from the strong trees nearby."
      },
      {
        product_name: "Magic in the Moonlight",
        product_id: "6850029584450",
        product_text: "A miniature winged kitten looks down from its perch on an iris into the eyes of another cat, its golden green eyes glowing as brightly as magic in the moonlight."
      },
      {
        product_name: "Unicorn Mother and Foal",
        product_id: "6850030141506",
        product_text: "A unicorn mother and her foal are resting on a flower-filled meadow before a brick archway that leads to an ocean and a world beyond. Another young foal can be seen in the distance next to a small colony of rabbits."
      },
      {
        product_name: "It’s Party Time",
        product_id: "6850030370882",
        product_text: "It’s party time in the garden and everyone has come out to play. From pink to purple, peach to pastel, the blooms emit vibrancy and warmth."
      },
      {
        product_name: "Rainbow Dreams",
        product_id: "6850030436418",
        product_text: "In a colorful and childlike cartoon scene of rainbow dreams, a blonde girl dressed in rainbow clothing kneels next to a toy, bright streaks of colors and stars dotted around her."
      },
      {
        product_name: "Bear Salmon Fishing",
        product_id: "6850031190082",
        product_text: "In the rushing rapids of a river, a bear salmon fishing for his family tastes success. Three cubs and his mate watch on in this expansive wilderness."
      },
      {
        product_name: "Neon Love",
        product_id: "6850031124546",
        product_text: "This girl’s electric-green hair is accentuated by a similar colored background and softened by a rainbow hair clip and starry earrings. However, we know there’s a dark side to this neon love, as suggested by her black slip and arrows sticking out of her doll’s heart."
      },
      {
        product_name: "Blossom Falls",
        product_id: "6850031353922",
        product_text: "The rushing water cascades down an unseen waterfall, yet the spray sparkles high, mingling with the pink blossoms of trees that are thriving so close to the cliff edge. These blossom falls showcase the diverse beauty of nature."
      },
      {
        product_name: "Serene Emperor",
        product_id: "6850030633026",
        product_text: "This very realistic depiction of a white tiger profile features the same color background as this powerful beast's eye. This serene emperor gazes out with a calm, almost bored expression on his face."
      },
      {
        product_name: "Bohemian Bonita",
        product_id: "6850030927938",
        product_text: "A bohemian bonita with her rasta dreadlocks adorned with feathers and charms stands draped in a purple poncho and wearing a crescent moon necklace."
      },
      {
        product_name: "Kitty Love",
        product_id: "6850031386690",
        product_text: "A chubby-cheeked fairy girl in strawberry-pink braids is showing some kitty love by cuddling her black cat as it sits on her lap. Pink flowers and butterflies create a pleasant background."
      },
      {
        product_name: "Tiger from the Embers",
        product_id: "6850032336962",
        product_text: "A vicious-looking tiger from the embers emerges, snarling and baring its yellow teeth as fires behind it rage on. Its large feet and pointed claws are close and portray the true power and size of this beast."
      },
      {
        product_name: "Tulips Galore",
        product_id: "6850031517762",
        product_text: "Tulips galore are spilling out from the blue jar they’ve been placed in. Butterflies and other blue flowers are also present as the pink, yellow, and orange flowers are on display."
      },
      {
        product_name: "Lakeside View",
        product_id: "6850031812674",
        product_text: "Sitting inside a timber-built room, one can look out to enjoy this lakeside view. Homely items are dotted all around the space, including two cats, a dog, and a book on how to paint. Looks like someone has gone fishing for the day."
      },
      {
        product_name: "Flurry",
        product_id: "6850032173122",
        product_text: "Tiny winged baby unicorns are in a flurry over a woman, her eyes as striking as the markings on their backs. The woman herself has a horn coming from her head, encompassed by a kind of crown."
      },
      {
        product_name: "Dolphin Bay",
        product_id: "6850031550530",
        product_text: "As the sun sets at Dolphin Bay, these frisky marine mammals marry the worlds both above and below the water. Explore the shore’s edge and forest beyond and dive deep to where sea turtles play among the coral."
      },
      {
        product_name: "Ace of Alice",
        product_id: "6850032369730",
        product_text: "This playing card comes right out of a deck from a fairytale. The Ace of Alice features our wonderland heroine sitting atop a toadstool, with the eyes of the Cheshire cat and mad hatter glowing from either side."
      },
      {
        product_name: "Jewels of the Lake",
        product_id: "6850032500802",
        product_text: "Water lilies sit atop an inky blue as the jewels of the lake. Three dragonflies hover around the pink blooms, and more delicate flowers add further beauty and color."
      },
      {
        product_name: "Lost in the Right Direction",
        product_id: "6850032533570",
        product_text: "It feels good to be lost in the right direction. These wise and uplifting words are printed among brightly colored doodles set against a pleasing pattern of black and white triangles."
      },
      {
        product_name: "Unicorn Family",
        product_id: "6850032664642",
        product_text: "A unicorn family is prancing around a field bursting with blossoms. As the baby relaxes, flowers and fairies can be seen in the foreground, and a lake shimmers pink in the magical glow behind them."
      },
      {
        product_name: "Sweet Koala",
        product_id: "6850032926786",
        product_text: "A sweet koala is smiling in the branches of a tree, surrounded by wildflowers that are reaching up from the ground and blossoms coming down from above. A yellow and white butterfly hovers nearby."
      },
      {
        product_name: "A Moment in Time",
        product_id: "6850033254466",
        product_text: "It is a rare moment in time when a lake lies so smooth that the trees in the distance and the vibrant hues in the sky can be marveled at twice."
      },
      {
        product_name: "Queen of Hearts",
        product_id: "6850033418306",
        product_text: "The queen of hearts wears a crown atop a shock of red and white hair that has been scraped off her heavily painted face. A small white rabbit plays the trumpet in the crook of her arm as the queen’s red-gloved hands hold her perfect face."
      },
      {
        product_name: "Dahlia Dance",
        product_id: "6850033451074",
        product_text: "The distinct globes of perfectly curved petals create this gentle and soft dahlia dance. Two large flower heads stand out from a backdrop of blurred lines as the flowers seemingly frolic with one another."
      },
      {
        product_name: "Valentine Bridge",
        product_id: "6850034532418",
        product_text: "Behind a deep pink blossoming tree that is hanging over a smooth lake is the valentine bridge, the arch mirrored perfectly in the water to create a circle. Two swans touch heads to create a heart between them."
      },
      {
        product_name: "Lovegarden",
        product_id: "6850033713218",
        product_text: "A digitally enhanced lovegarden sits bright, where flowers bloom in the shape of hearts and butterflies flit in the bright summer’s day. Look hard and you’ll see a rainbow in the distance."
      },
      {
        product_name: "A Memorable Afternoon",
        product_id: "6850033549378",
        product_text: "A memorable afternoon is spent sitting in this sun-kissed coastal scene. There is tea for two atop a table surrounded by roses and two white wicker chairs."
      },
      {
        product_name: "True Love",
        product_id: "6850033320002",
        product_text: "True love may be within this girl’s grasp as a red and white-haired angel clasps a sparkling heart-shaped gem in her gloved hand. Her eyes are ruby-red, but another bright blue eye can be seen clipped in her hair."
      },
      {
        product_name: "Blooming Bonnet",
        product_id: "6850034171970",
        product_text: "A bouquet of blossoms creates this blooming bonnet atop the head of a sweet girl whose head rests comfortably in her hands. One eye is covered by a butterfly, the other shines a dazzling blue."
      },
      {
        product_name: "Fragility",
        product_id: "6850034303042",
        product_text: "There is fragility in a single rose as the petals slowly drip away into nothingness. The delicacy in this watercolor image is augmented by the bold choice of vivid pinks and yellows."
      },
      {
        product_name: "Purple Passion",
        product_id: "6850034827330",
        product_text: "Picked fresh from the garden and placed in a glass jar on a table is a bountiful selection of foliage and blooms – a moment of purple passion to be taken in and enjoyed."
      },
      {
        product_name: "Peacock’s Lagoon",
        product_id: "6850035056706",
        product_text: "Within this peacock’s lagoon which is hugged by tall trees and even taller mountains is a golden structure holding orbs of beautiful flowers. Two peacocks perch here in front of an otherworldly sky."
      },
      {
        product_name: "The Most Curious of Them All",
        product_id: "6850035318850",
        product_text: "Alice sits on top of a mushroom holding a cupcake that says ‘eat me.’ Is she the most curious of them all? The caterpillar and the Cheshire cat both want to know."
      },
      {
        product_name: "Midnight Call",
        product_id: "6850035777602",
        product_text: "As the clouds part to reveal the bright moon, a wolf stands on a stone in the middle of a river to make his midnight call. Two other wolves can be seen in the distance as eagles soar in the air of this natural wild scene."
      },
      {
        product_name: "One Love",
        product_id: "6850035482690",
        product_text: "There is but one love around the world, as this young girl with flowers in her hair knows. She wears a rainbow and hearts t-shirt and is standing before an image of the world with trees, flowers, mountains, and more all lying around it."
      },
      {
        product_name: "Best Friends",
        product_id: "6850035679298",
        product_text: "In this colorful and happy scene, these best friends – three kittens and a puppy – are happily sitting in a garden of wisteria and pansies as butterflies delight in their youthful desire to play."
      },
      {
        product_name: "Sunday Morning in Spring",
        product_id: "6877095395394",
        product_text: "It is Sunday morning in spring, and the villagers are flocking to the local church. Set in a romantic period of horse and cart, the houses are few but beautifully designed, and life in the village is plentiful."
      },
      {
        product_name: "Little Owl",
        product_id: "6850035843138",
        product_text: "A little owl sits on a branch outside his tree stump home, several round windows traveling up the stump glowing brightly. The teetering tree curves over a winding stream that is hugged by wildflowers."
      },
      {
        product_name: "Mystical King",
        product_id: "6877093658690",
        product_text: "A snow-white lion with piercing blue eyes is surely a mystical king from unknown places. This close and personal portrait shows exquisite detail, from his soft fur and mane to the imperfections on his nose."
      },
      {
        product_name: "Meet Me At The Diner",
        product_id: "6877094608962",
        product_text: "Blood-red pinned-up curls, held in place by a posy of purple flowers, are perched on the head of this luscious-lipped beauty. Her bright green eyes say, “come meet me at the diner,” which she stands in front of."
      },
      {
        product_name: "Have I Gone Mad",
        product_id: "6877094117442",
        product_text: "“Have I gone mad?” asks Alice as she stands before piles of teacups, clasping one of her own while cradling a small mouse in her other hand. The Mad Hatter’s hat rests upon her own head."
      },
      {
        product_name: "Stargazer",
        product_id: "6877094903874",
        product_text: "Beautiful deep pink daylilies have been picked and brought inside for every stargazer to enjoy. There are speckles on the petals and the stamens emerging haphazardly from the flowers, emphasizing the beauty in each bloom."
      },
      {
        product_name: "Family at The Jungle",
        product_id: "6877898276930",
        product_text: "A cascading waterfall far in the distance flows forward to reach the family at the jungle pool. These stately tigers and cubs relax around and in the pool as other jungle favorites add color and life."
      },
      {
        product_name: "Alice’s Bunnyguards",
        product_id: "6877898539074",
        product_text: "Alice’s bunnyguards are keeping a watchful eye over their blonde-haired master, their soft red eyes the same color as the roses that brighten this sepia scene."
      },
      {
        product_name: "Lakeside Paradise",
        product_id: "6877898801218",
        product_text: "Evening settles in at this lakeside paradise, where houses are dotted along the edge of the calm expanse of water. A stone footbridge rises over a narrow section of the lake, and a rowboat is anchored close by."
      },
      {
        product_name: "Butterfly Daisy Heart",
        product_id: "6877899128898",
        product_text: "A stunning canary-yellow butterfly sits peacefully in the middle of a blue heart. Daisies surround this and are superimposed on top of a purple flower pattern, forming a digitally enhanced butterfly daisy heart that delights."
      },
      {
        product_name: "It’s in the Detail",
        product_id: "6877899784258",
        product_text: "It’s in the detail of each dahlia petal that you can find perfection in the nature that is all around us. Every segment plays its part to create the perfect globe-like flower in every shade imaginable."
      },
      {
        product_name: "Wolf Wilderness",
        product_id: "6877900079170",
        product_text: "The snowy wolf wilderness is a cold and icy place, with ice cliffs rising high and the lights from above shining down on the frozen water below. A huge wolf’s head is superimposed in the sky with light shining strongly from behind it."
      },
      {
        product_name: "Waiting for Wonderland",
        product_id: "6877900406850",
        product_text: "Alice is waiting for wonderland, a key wrapped in the ribbons of her hair and the Cheshire cat smiling as he perches on her shoulder. She wears a blue puff-sleeve dress underneath an apron, as well as a choker necklace with a lock on the front."
      },
      {
        product_name: "Lady Luck",
        product_id: "6877900668994",
        product_text: "Wearing a national color of good luck, happiness, and success, this lady luck is dressed modestly in red Chinese attire and stands before a bold pattern of vibrant gold. Her dark hair and the backdrop make these colors pop even more."
      },
      {
        product_name: "Mystic Garden",
        product_id: "6877900931138",
        product_text: "Welcome to the mystic garden. A fountain splashes water into a man-made pool, before which lounge two white tigers. Two peacocks and other birds perch on a strange ornament ahead of steps that lead to the unknown."
      },
      {
        product_name: "Flora and Fable",
        product_id: "6877901226050",
        product_text: "Sitting in a field of flowers, a fairy sits and reads a book to a baby dragon, her deep purple eyes the same color as her hair. A scene of flora and fable transports you to an enchanting space."
      },
      {
        product_name: "Unicorn Keeper",
        product_id: "6881675444290",
        product_text: "The unicorn keeper holds her clawed fingers up to her mouth as she cradles a baby unicorn in her arms. She wears a unicorn crown and a spiked heart in her white hair. Her almond-shaped eyes are a soft, deep blue."
      },
      {
        product_name: "Wonderland Potion",
        product_id: "6877901488194",
        product_text: "Alice holds a teacup loosely in her hand, inside of which a wonderland potion can be seen. She holds a white rabbit close to her chest and wears another on a locket at her throat. Time is ticking by – does she have the key?"
      },
      {
        product_name: "Lion",
        product_id: "6877901062210",
        product_text: "A lion and a cub sit together in the forefront of this safari grassland. Flamingos mill nearby, as well as a lone giraffe and some antelope in the background. A snowy, flat-topped mountain stands in the distance."
      },
      {
        product_name: "Spring is Here",
        product_id: "6881675903042",
        product_text: "Can you see that spring is here from this bouquet of blooms simply bursting with color and life? Tulips in red, yellow, and pink are bunched together with daffodils and more in a beautiful display."
      },
      {
        product_name: "Spring Owlets",
        product_id: "6881676165186",
        product_text: "Two spring owlets look completely shocked as a couple of bright butterflies flit past their blossoming perch. Mother owl watches on from behind in this colorful and character-filled scene."
      },
      {
        product_name: "Magnolia Spring",
        product_id: "6881676394562",
        product_text: "An archway of blossoms guides you to a body of water, the magnolia spring a delight of strikingly bright pinks and deep, moody blues. A stand of trees can be seen on the other side of the water."
      },
      {
        product_name: "Pretty in Pastel",
        product_id: "6881676886082",
        product_text: "Dressed in a sage-green shirt and wearing soft pink roses in her hair, this brown-haired and freckled beauty is so pretty in pastel. The exquisite shading of the roses adds a depth that is only rivaled by the huge pools that are this woman’s eyes."
      },
      {
        product_name: "Sweet Dreams Candy Store",
        product_id: "6896268542018",
        product_text: "Glistening donuts, swirling candy and frosting covered cakes, ‘Candies Sweet Dreams Bakery’ is a treat to behold.  The air is filled with the smell of freshly baked goods, as sweet as sugar. Just in time for Valentine's Day."
      },
      {
        product_name: "Fat Cat",
        product_id: "6896268804162",
        product_text: "A dapper gentleman tabby gazes out from a perfectly perched monocle. He has not yet eaten the bird on his hat, because he knew it would accentuate his style. Emphasis on the ‘not yet’."
      },
      {
        product_name: "Flower Froggie",
        product_id: "6896269197378",
        product_text: "This psychedelic froggie is brimming with flower power. Intertwined with vines and floral blooms, this frog is at one with nature. Surrounding him are flashes of colour, that have attracted some curious dragonflies."
      },
      {
        product_name: "City of Wands",
        product_id: "6896267427906",
        product_text: "Hidden within a lush rainforest, is the City of Wands. Two knights, mounted on fearsome gilded dragons, guard the gates. The City’s golden turrets glisten into the sky and the air fizzes with magic."
      },
      {
        product_name: "Bunny Bouquet",
        product_id: "6881677475906",
        product_text: "This bunny bouquet is a springtime delight, with daffodils and daisies bundled together and three busy bunnies, all with purple bows around their necks. As they sit on an outside table, birds and butterflies come to join the fun."
      },
      {
        product_name: "Easter Cupcake",
        product_id: "6896268902466",
        product_text: "Framed by lush tulips and colourful Easter eggs, this cupcake looks good enough to eat. Topped with a swirl of frosting and sprinkles, this makes the perfect Easter treat."
      },
      {
        product_name: "Easter Egg Hunt",
        product_id: "6896269131842",
        product_text: "Follow the path from the cottage to the meadow. In-between the daffodils and the daisies, the crocuses and the violets, are bundles of sweet eggs. The blue birds and the butterflies have already found some."
      },
      {
        product_name: "One’s Enough",
        product_id: "6896269000770",
        product_text: "This adorable bundle of fluff is all you need. You found this friendly critter nestled beneath the floral table cloths. How did he get here? One bunny is enough."
      },
      {
        product_name: "City of Swords",
        product_id: "6896267526210",
        product_text: "High above the clouds, the City of Swords pierces the sky. Its heavenly turrets are crested with emblems of Pegasus. Soldiers mounted on these flying horses, guard the angelic realm of the City, weaving between clouds, doves and rainbows."
      },
      {
        product_name: "Rainbow Ranger",
        product_id: "6896267001922",
        product_text: "The rainbow ranger is technicoloured. He holds a rainbow studded guitar, which plays streaks of light into the atmosphere. Peace and love fills the air in electric bursts of colour."
      },
      {
        product_name: "Cosmic Tree of Life",
        product_id: "6896267100226",
        product_text: "At the gate of eternity, lie the roots of an ancient tree. It spirals into the heavens with green, blue and pink sparks. Its branches hold the secrets of life within its leaves."
      },
      {
        product_name: "Teddy Bear",
        product_id: "6896270671938",
        product_text: "Elegant, Rococo curls frame the face of this damsel. She wears a black ruffle dress and black bow. In her hair, she wears two teddy bear accessories. One bear is of the rain and the other is of the night."
      },
      {
        product_name: "1950s Hollywood Street",
        product_id: "6896268705858",
        product_text: "Everyone is inside listening to rock n’ roll while the Hollywood sign blooms on the hill behind. Two dogs wait patiently in the back of a truck, while the sun sets in the sky."
      },
      {
        product_name: "Ye Old Stitching Room",
        product_id: "6896268312642",
        product_text: "While away the hours between the yarn and the patchwork in this cosy stitching room. A fresh pot of tea is waiting for you. The cat is already purring in the corner, on this lazy afternoon."
      },
      {
        product_name: "World Thinker",
        product_id: "6896266707010",
        product_text: "A celestial figure gazes down from the heavens. He is peaceful and as his thoughts drift, small planets and hummingbirds orbit his mind. The Earth is at peace."
      },
      {
        product_name: "Kitten in a Mug",
        product_id: "6896269164610",
        product_text: "Well, some cats must like water! This curious kitten is cosied up inside a mug. She is surrounded by floral details and brilliant, bright colours. She is letting the stress melt away."
      },
      {
        product_name: "Lily",
        product_id: "6896268771394",
        product_text: "Lily is a southern belle and miniature schnauzer, confidently holding her fan in her paw. In her lace and pearl embroidered clothes, she’s a woman of style as well as class."
      },
      {
        product_name: "Humpty Dumpty Smile",
        product_id: "6896266969154",
        product_text: "Humpty Dumpty is smiling on top of his wall. The sun is a rainbow blaze. There is tea at hand and no falls to be had."
      },
      {
        product_name: "Cinderella’s Castle",
        product_id: "6896267231298",
        product_text: "The moon has just risen, as Cinderella’s carriage dashes through the castle gardens.  The cherry blossoms are singing their sweet scent into the night, yet all she can think of is the ball."
      },
      {
        product_name: "Autumn Church Frame",
        product_id: "6896267493442",
        product_text: "The last summer breeze is drifting in through this open window. It carries the scent of late blooms and the ring of church bells. The river rushes by and all is calm on this Sunday afternoon."
      },
      {
        product_name: "Koi Fish Puzzle",
        product_id: "6896268214338",
        product_text: "Koi drift elegantly by, in a shimmering blue pond, dotted with water lilies. Below the surface, a mirage of koi coalesce in white, red, copper and gold by the riverbed."
      },
      {
        product_name: "Wolf Shaman",
        product_id: "6896269328450",
        product_text: "Brilliant streaks of blue, pink and purple adorn this regal wolf. The details that decorate his face, belie his spiritual prowess. His eyes are watchful, almost as though he is gazing into your soul."
      },
      {
        product_name: "Secret Heart",
        product_id: "6896270573634",
        product_text: "On the Dias de los Meurtos, an undead beauty rises from the night. Her sugar skull makeup is still fresh on her face. A golden, clockwork heart beats on her chest. Alive once more."
      },
      {
        product_name: "Psychedelic Lion",
        product_id: "6896266936386",
        product_text: "Above the Earth, a miracle of light is blossoming. From the crystals of the aurora borealis, a lion gazes out into the galaxy."
      },
      {
        product_name: "Magical Moment in Time",
        product_id: "6896267460674",
        product_text: "Allow the hours to slip away, in this tropical paradise. Two gleaming white tigers dwell in this galactic jungle. Ripe mangoes hang from green canopies, above a pool of golden koi. The sun rises below the temple clock, which beats to the turn of the stars."
      },
      {
        product_name: "Mason",
        product_id: "6896269361218",
        product_text: "A refined Labrador, with a coat of gold, Mason is a charming young dog. He wears a dashing coat with gold buttons, a matching top hat and cane. Perfect for an up-and-coming gentleman such as he."
      },
      {
        product_name: "Let Them Eat Cake",
        product_id: "6896269885506",
        product_text: "The lady Marie Antoinette, poses for a royal portrait. Her sweeping white gown and signature white hair are decorated with roses and a swallow.  The sky behind her is ominous and her cake, might just be filled with poison."
      },
      {
        product_name: "Bike Sunset",
        product_id: "6896268738626",
        product_text: "Soak up the last of the pastel sky, as the sunsets over this carefree scene. A blue bike waits among sand and seashells. Inside a Labrador puppy, peeks out from freshly cut flowers, waiting for the ride home."
      },
      {
        product_name: "The Palace",
        product_id: "6896269099074",
        product_text: "The bells of Big Ben are chiming, as the London fog creeps over Westminster. The streets light up with red double-decker buses and pedestrians walking home in the rain."
      },
      {
        product_name: "Fall Fairy",
        product_id: "6896267132994",
        product_text: "The summer has faded, and the Fall fairy must turn the colours of the leaves. Her magic transforms green into a flurry of amber and gold. Hidden between the trees and toadstools, tiny fairies watch her work."
      },
      {
        product_name: "Tiki Beach Sunset",
        product_id: "6896268640322",
        product_text: "The sun is just setting on this beach front paradise. The day has drifted away, but the Tiki bar is awash with lanterns. A tropical aquarium bubbles away, and a ukulele waits to be played. Stay for a while, the piña colada is on the house."
      },
      {
        product_name: "Supernova",
        product_id: "6896269262914",
        product_text: "Beautiful rays of light, beam out from the sun’s smiling face. They reach out across the galaxy in celestial bursts of colour, illuminating the planets, stars and moons."
      },
      {
        product_name: "The Conservatory",
        product_id: "6896267690050",
        product_text: "The sweet mountain air drifts in through the open conservatory doors. From the English walled garden, the fountain is trickling gently. There are colourful blooms collecting in the flower beds. Enjoy the spring glory, with a fresh cup of tea."
      },
      {
        product_name: "Bird House Garden",
        product_id: "6896268083266",
        product_text: "In a flurry of feathers, a flock of birds rest on multicoloured bird houses. Bumblebees buzz lazily by in this vibrant garden, while the birds chatter amongst themselves."
      },
      {
        product_name: "Ashley",
        product_id: "6896268869698",
        product_text: "Her royal highness, Princess Ashley, is first in line for the throne. Her tiara and her gown are still a little too big for her, but she already has the grace of a princess."
      },
      {
        product_name: "Clora",
        product_id: "6896269623362",
        product_text: "Clora’s gothic style turns the world on its head. Her long grey hair, frames her youthful face and her striking spider-webbed gown features an eerie brooch, filled with sharp teeth."
      },
      {
        product_name: "Moonlight Magic",
        product_id: "6909572284482",
        product_text: "The moon shines a mystical haze over this fantasy oasis, bathing everything in lilac. A beautiful pegasus with dragonfly wings bathes in the soothing waters between an abundance of flowers and butterflies."
      },
      {
        product_name: "Insane in the Membrane",
        product_id: "6909573234754",
        product_text: "Springing out of a psychedelic dream, this vibrant puppy is a kaleidoscope of colors. From its serene blue eyes to its fluffy coat, this pup is a spirit of the rainbow in green, yellow, orange, pink, purple, and blue."
      },
      {
        product_name: "Rose Fairy",
        product_id: "6909576872002",
        product_text: "A lady of the roses, this dignified fairy brings the petals of the garden to life. Each bloom is embroidered in her beautiful pink ball gown. She fills the air with her magic, which sparkles in her eyes."
      },
      {
        product_name: "Kim’s Garden",
        product_id: "6909577134146",
        product_text: "Take a moment to rest beside the flowers. Leave the world behind the garden walls and nestle down between the roses and the snapdragons. The air is filled with a sweet scent, and this cozy bench is the perfect reading nook."
      },
      {
        product_name: "Summer in Tuscany",
        product_id: "6909577363522",
        product_text: "Dazzling heat and fine Italian cuisine await you in this Tuscan holiday dream. Enjoy a glass of wine and good conversation, al fresco, at this charming restaurant overlooking the rolling countryside."
      },
      {
        product_name: "Hummingbird Pink",
        product_id: "6909577887810",
        product_text: "A green hummingbird stumbles upon a bundle of pink columbines. The petals are delicate and touched with a sweet fragrance that fills the air. The spring morning is brimming with bird song and sunlight."
      },
      {
        product_name: "Spring at The Cabin",
        product_id: "6909577986114",
        product_text: "Deep in the woods, smoke rises from the chimney of a cozy cabin. Over the brook beneath the trees, a host of animal friends welcome in the spring. The fawn gazes out at the woods while the others stop to smell the flowers."
      },
      {
        product_name: "Aunt Teaks Antique Store",
        product_id: "6909573988418",
        product_text: "Anything you can imagine, you can find at Aunt Teak’s antique store – vintage teapots, odds and ends, cozy cushions, and rocking chairs. Each item has a story to tell, and Aunt Teak knows them all, so come on in and stay a while."
      },
      {
        product_name: "Emanate",
        product_id: "6896269721666",
        product_text: "Dazzling beneath the waves, a shimmering mermaid sings softly through the night. Her turquoise and chestnut hair, is dotted with pearls. Her narwhal friends keep her company in the dark."
      },
      {
        product_name: "Zang Tigers",
        product_id: "6909577560130",
        product_text: "A powerful mother tiger rests on a canyon cliff. Towering mountains stretch into the sky behind her. An eagle screeches into the wind. The mother’s tiny cubs play around her, unaware of the natural wonders behind them."
      },
      {
        product_name: "Psychedelic Sea Turtle",
        product_id: "6896269295682",
        product_text: "This psychedelic sea turtle, is drifting without a care in the world between the coral and the angelfish. His kaleidoscopic colours, radiate out from the blue ocean."
      },
      {
        product_name: "Firebird Panorama",
        product_id: "6896268378178",
        product_text: "In this ancient temple, the Firebird spreads its wings of flames and ignites the scene. Between the opulent gold ornaments, peacocks wait patiently by its side, preventing two knights from combat."
      },
      {
        product_name: "Majestic Mansion",
        product_id: "6909572218946",
        product_text: "Get away from it all in this beautiful mansion. The wide acres of well-groomed gardens have bloomed just in time for spring. It truly is the perfect escape to the countryside among all the butterflies, flowers, and hedgerows."
      },
      {
        product_name: "Aloha",
        product_id: "6909574578242",
        product_text: "This island beauty is a picture of serenity in the tropical jungle. Her hair is adorned with flowers, and garland blooms decorate her neck and wrists. Her grass skirt blows in the paradise breeze as blue and green parrots chirp around her, welcoming the last of the evening sun."
      },
      {
        product_name: "Out of this World",
        product_id: "6909573857346",
        product_text: "Join this adventurous astronaut in the depths of space. There is no need for gravity. Float by in the brilliant blue and purple glow of the stars – there are galaxies out there waiting for you."
      },
      {
        product_name: "Villa Angelica",
        product_id: "6909574611010",
        product_text: "While away a sunny afternoon relaxing on this plush velvet chaise lounge. Before you is exquisite Renaissance artwork adorning the cloister. In the distance are the equally picturesque hills of the Tuscan countryside."
      },
      {
        product_name: "Magical Community Garden",
        product_id: "6909574774850",
        product_text: "Between their rainbow-colored houses, the villagers work joyfully to grow their garden. Up the hill to the orange tree are patches of carrots, potatoes, and wheat. Love and friendship are the magic of the garden."
      },
      {
        product_name: "Ember",
        product_id: "6896269754434",
        product_text: "This mysterious girl, in a black lace gown, doesn’t seem quite human. Her copper hair, weaves into the vines and thorns of the roses.  They seem to come to life too, must be her magic."
      },
      {
        product_name: "Tree of Wisdom",
        product_id: "6909574938690",
        product_text: "On a lone hill, piercing into the blue sky, stands the Tree of Wisdom. Persevering through the centuries, you can’t help but wonder what secrets it must know. Listen closely – you might hear them in the whispers of the leaves."
      },
      {
        product_name: "Coral Reef Island",
        product_id: "6909577429058",
        product_text: "This rainbow coral reef is teeming with life. Swim through the warm ocean with shoals of tropical fish. Explore the treasure of a sunken shipwreck with friendly dolphins. There is a whole world to explore under the sea."
      },
      {
        product_name: "Wizards Workshop",
        product_id: "6896268443714",
        product_text: "Something is brewing between the relics and spell books in the Wizard’s workshop. Fire shoots from a container and blends with a shock of lightning that has unsettled the owl. The cat sleeps, none the wiser, until his master’s return."
      },
      {
        product_name: "Fairy Song",
        product_id: "6909577003074",
        product_text: "This beautiful nymph plays her flute to beckon the sun from the night. The sweet, unearthly music fills the fresh morning air. The notes awaken the flowers and the trees before this fairy must take flight."
      },
      {
        product_name: "Bluebirds of Summer",
        product_id: "6909577658434",
        product_text: "Dappled sunlight washes over this charming summer scene. Two bluebirds rest atop echinacea flowers, surrounded by forget-me-nots. They are mesmerized by the vitality that summer brings to the garden."
      },
      {
        product_name: "Canada Cupcakes",
        product_id: "6929789419586",
        product_text: "Celebrate Canada day with these patriotic cupcakes. Topped with mini Canadian flags and bursting with national pride in red and white, these sweet treats will make everyone’s day at this year's local Canada day celebrations."
      },
      {
        product_name: "Happy Canada Day",
        product_id: "6929789255746",
        product_text: "O Canada! Our home and native land! As the Canada Day festival comes to an end, fireworks erupt through the sky. Beneath it all, a family of patriotic Canadians gazes up at the sun setting over their homeland."
      },
      {
        product_name: "Scenic Steamer",
        product_id: "6909574479938",
        product_text: "Watch the world go by from the carriage of this charming old steam train. As it chugs through the winding countryside, smoke billows into the sky. It travels by the mountains, over a quaint brook, and past the woodland critters through the trees."
      },
      {
        product_name: "Extinct",
        product_id: "6896269787202",
        product_text: "This figure’s billowing purple gown and cascading hair, blows through the winds of time. A young triceratops rests in her lap. Time has warped and history has opened."
      },
      {
        product_name: "Time to Relax",
        product_id: "6909573169218",
        product_text: "This pocket of serenity is the perfect place to relax and unwind. The woodland cabin is surrounded by blooming spring flowers, birds, butterflies, and newborn bunnies. Dance over the stepping stones and let the world slip away."
      },
      {
        product_name: "Blueberry Lunch",
        product_id: "6909574709314",
        product_text: "Hidden between the lush leaves of their woodland home, the tiniest bunnies share ripe blueberries with their field mouse friends. The berries are tart and sweet like candy. Moments of joy are best shared with furry friends."
      },
      {
        product_name: "A Peaceful Celebration",
        product_id: "6909572907074",
        product_text: "Color fills the sky on this Fourth of July night. Hues of red, white, and blue reflect on the serene waters of the lake. Above, the Stars and Stripes flag waves proudly, symbolizing the spirit of the United States."
      },
      {
        product_name: "Old Town USA",
        product_id: "6929789059138",
        product_text: "The town is lined with red, white, and blue in this darling old-time scene. Stars and Stripes flags pepper the cobbled streets filled with charming stores, where the townsfolk prepare for the big day ahead."
      },
      {
        product_name: "Sunrise Salute",
        product_id: "6929789583426",
        product_text: "Three brave soldiers stand to attention as the sun rises over the proud and free American nation. Everything they serve to protect stretches out before them. Above them, the mirage of a Stars and Stripes flag fills the sky with red, white, and blue."
      },
      {
        product_name: "Fourth Family",
        product_id: "6929790107714",
        product_text: "Perched by the bandstand under the firework-filled sky is a family of patriotic critters. Puppies, kittens, a hamster, and a budgie make up this unlikely group of Fourth of July friends – a reminder that the land of the free is a home for everyone."
      },
      {
        product_name: "Colorful Amsterdam",
        product_id: "6909574807618",
        product_text: "The streets of Amsterdam explode with color in this technicolor scene. The rooftops vibrate with sparks of yellow, pink, and blue. Behind the rainbow buildings, the sun sets in an orange frenzy, lighting the sky and the canal on fire."
      },
      {
        product_name: "Iris",
        product_id: "6896269852738",
        product_text: "Iris is a striking young witch, with untold powers. She waits, with her familiar Star, for the moon to rise. Secrets of the night, blow through her hair, magic is about to begin."
      },
      {
        product_name: "Oh, Wise One",
        product_id: "6909573300290",
        product_text: "The mysteries of the universe unfold in the piercing amber gaze of the owl. This wise spirit exudes a glowing pink, purple, and blue aura. Its feathers flicker with sacred flames from the other realm."
      },
      {
        product_name: "The Cabin in the Woods",
        product_id: "6909577756738",
        product_text: "Between the fall leaves, a family of birds prepares for winter. A cabin birdhouse, hand-built with care, provides the bluebirds, great tits, and cardinals with shelter from the cold."
      },
      {
        product_name: "Headlights on the Lake",
        product_id: "6909573922882",
        product_text: "Nothing is more enticing than the rustic charm of a simple life in the great outdoors. Life here is slow, and you can enjoy the sweeping scenery of the forest filled with wildlife and the blue waters of the lake. A rugged truck has stopped by to enjoy this vision of bliss."
      },
      {
        product_name: "Amusing",
        product_id: "6909575823426",
        product_text: "A beautiful ice queen stands tall in the snow-covered palace gardens. Embellished in midnight blue, she wears a billowing ball gown and a top hat with steampunk gears. Between the folds of her dress is a carousel that sings softly with music."
      },
      {
        product_name: "Wings of Wonder",
        product_id: "6909573201986",
        product_text: "Somewhere over the rainbow is a dazzling meadow filled with pink flowers and quartz crystals. This is the home of a beautiful pegasus. With its shining coat and monarch butterfly wings, it can fly faster than any bird."
      },
      {
        product_name: "A Different View",
        product_id: "6909577068610",
        product_text: "Enjoy the view of the rolling Tuscan countryside from this cozy balcony. Fresh wine and cheese have been brought over from the farmhouse. It’s time to enjoy lunch in the sunshine with friends."
      },
      {
        product_name: "Pink Valenstein",
        product_id: "6896270475330",
        product_text: "Pink Valenstein is love struck. As soon as she came to life, she knew she had to find her love. Deep in the woods, the sky is turning pink, and she must wait for Frankenstein to arrive."
      },
      {
        product_name: "Morning Walk",
        product_id: "6909574381634",
        product_text: "A couple walks hand in hand along a romantic, winding road. Beside them, the sun is rising behind the cliffs over crashing waves. It fills the sky with golden light. Love is in the air and home is just a moment away."
      },
      {
        product_name: "Glowing Snow Leopard",
        product_id: "6909573529666",
        product_text: "Embodying fire and ice, this majestic snow leopard is fierce yet cool and collected. Its fur flickers with glacial tones yet sparks with embers. Its eyes reflect this dual power, one an icy blue and the other a fiery red."
      },
      {
        product_name: "Garden Flower Monarchs",
        product_id: "6909577920578",
        product_text: "Within this sage-green garden, two monarch butterflies nestle among the flowers. They have landed on two purple echinacea to take a drink. Around them, snapdragons and forget-me-nots brim with life."
      },
      {
        product_name: "The Edge of Fantasy",
        product_id: "6909573136450",
        product_text: "Take in the sea air and the scent of forest leaves to the sound of the sea crashing. The sunset washes over the rugged coastline as the lighthouse guides a newly sailed ship over the sea. There are new beginnings in sight."
      },
      {
        product_name: "Theodore",
        product_id: "6909577166914",
        product_text: "The perfect sailing pal, Theodore loves the sea. This sweet-natured teddy waits patiently in a baby blue living room with his toy boat, ready for his next trip."
      },
      {
        product_name: "Clouded Yin Yang",
        product_id: "6909573726274",
        product_text: "High in the atmosphere, celestial powers convene in rich purple and blue hues. Billowing clouds flood the starlit sky. These opposite yet interconnected forces create balance in the chaos of the universe."
      },
      {
        product_name: "Dragonfly Kiss",
        product_id: "6909576937538",
        product_text: "The fairy of the forest lights up with joy. Through the leaves and dappled sunlight is a visitor. She greets her dragonfly friend with a kiss – it has been far too long."
      },
      {
        product_name: "Dragonfly Kiss",
        product_id: "6943517671490",
        product_text: "Nestled deep within a snowy forest, is your own festive holiday cottage. Like a life-sized gingerbread house, this Christmas cottage is covered in snow. Outside the warm glow of fairy lights, carefully wrapped around the forest trees, welcome reindeer and snowmen friends home for the holidays."
      },
      {
        product_name: "Ye Old Christmas Shoppe",
        product_id: "6943519342658",
        product_text: "Step inside this cosy Christmas Shop, brimming with holiday ornaments and trinkets. The air is filled with cinnamon as you enter and a Christmas puppy comes to greet you. The shelves are adorned with nutcrackers and garlands, teddy bears and toy trains, there are many surprises to be found."
      },
      {
        product_name: "Santa’s Secret",
        product_id: "6943520653378",
        product_text: "Shhhhh! Santa Claus has just arrived. It’s Christmas Eve and he’s delivering beautifully wrapped gifts to children far and wide. New toys overflow from Santa’s sack; teddy bears, toy drums, soldiers and trains, bringing smiles to children’s faces on Christmas morning."
      },
      {
        product_name: "White Christmas",
        product_id: "6943521308738",
        product_text: "An abundance of gifts are waiting for you on this pristine Christmas morning. Gather round the roaring fire, and share the Christmas cheer with family and loved ones. Decorated with gold ornaments and green garlands, Christmas spirit radiates from every corner of this elegant, white home."
      },
      {
        product_name: "Snowman and Birds",
        product_id: "6943522160706",
        product_text: "Bathed in the glow of a flickering streetlight, a smiling snowman waits for Santa Claus to arrive. His bird friends keep him company, perched on his outstretched arms and on perfect bird houses beside him. This winter snowman is surrounded by joy and friendship on Christmas Eve."
      },
      {
        product_name: "Christmas Parade",
        product_id: "6943522717762",
        product_text: "Dashing through the snow, Santa’s sleigh races through a winter wonderland. Join this jolly old fellow and his team of reindeer as they deliver gifts to the children of the world. As they race by, the crisp night air is filled with the sound of jingle bells, captivating the hearts of woodland creatures."
      },
      {
        product_name: "Mountain View",
        product_id: "6909574447170",
        product_text: "A charming cottage nestled in the midst of majestic mountains stands as a haven of tranquility. Adorned with blooming flowers, exudes a rustic charm that perfectly complements the natural beauty of the surrounding landscape. Such a breathtaking view that reminds us of the beauty and serenity found in the heart of nature."
      },
      {
        product_name: "Floral La Femme",
        product_id: "6909575004226",
        product_text: "A mesmerizing blend of artistry and nature unveils a woman of exquisite grace. Her elegant gown crafted entirely from a rich tapestry of flowers, captures a harmonious fusion of human grace and the wonders of nature, evoking a sense of wonder and appreciation for the artistic beauty that can be found in both the cultivated and wild realms."
      },
      {
        product_name: "Purple Princess",
        product_id: "6909577035842",
        product_text: "In a distant purple world, there lived a majestic Purple Princess. Her unrivaled style radiated a distinctive charm that set her apart. As she left her mark on the realm with style, step into her mesmerizing domain and let her royal purple tones enchant your heart."
      },
      {
        product_name: "Aegean Sea",
        product_id: "6909577265218",
        product_text: "In the heart of the village, the streets wind between charming white buildings adorned with splashes of cobalt blue. Sit, enjoy a glass of wine, and observe the beauty of the Aegean Sea, where every wave whispers tales of ancient myths and distant adventures."
      },
      {
        product_name: "Viola",
        product_id: "6896270803010",
        product_text: "Viola embodies both the allure of the arcane and the enigma of hidden depths. She wears a dramatic witch hat that casts a shadow over her expressive eyes, and a feline companion perched on her neck hinting at her arcane powers and mystique. Her ombre hair, transitioned seamlessly from shades of purple at the roots to vivid blues that dance like ethereal flames toward the tips, adding to the aura of enchantment and intrigue."
      },
      {
        product_name: "Autumn Treasures",
        product_id: "6909572644930",
        product_text: "A charming farm scene adorned with a weathered wooden cart brimming with pumpkins, a cascade of fall leaves, and delicate wildflowers. A symphony of warm hues captures the essence of the season's bountiful embrace."
      },
      {
        product_name: "Whitetail Dawn",
        product_id: "6909577822274",
        product_text: "Surrounded by a lush and serene forest, two deer gazes ahead with a mix of curiosity and caution, their senses attuned to every rustle and whisper of the wilderness. Dew-kissed grasses and fallen leaves beneath its hooves bear witness to the quiet beauty of the dawn."
      },
      {
        product_name: "Route 66",
        product_id: "6909574873154",
        product_text: "A scene straight out of yesteryears unfolds, offering a captivating glimpse into the past. The iconic Route 66, a highway that once symbolized the promise of cross-country adventure, becomes a canvas for the vivid hues of history."
      },
      {
        product_name: "The Special Gift",
        product_id: "6943528714306",
        product_text: "Step into the enchanting world of Santa's workspace, where holiday wonders come to life. As Santa continues his work, one can almost hear the distant jingle of bells and the soft padding of reindeer hooves. The anticipation of Christmas Eve hangs in the air, and the reindeer toy begins to embody not only Santa's artistry but also the spirit of giving, wonder, and the joy of the holiday season."
      },
      {
        product_name: "Holiday Treasures",
        product_id: "6943529467970",
        product_text: "A beautiful moment of seasonal delights, showcasing an array of twinkling lights, ornate ornaments, and whimsical decorations. Each item seems to have a story to tell, and even from the other side of the glass, the cozy ambiance radiates joy and comfort, making it an irresistible haven for all who pass by."
      },
      {
        product_name: "Reindeer Lights",
        product_id: "6943530352706",
        product_text: "A majestic reindeer adorned with a breathtaking display of glowing lights. Against the backdrop of the night, the reindeer's form is outlined in a mesmerizing dance of colors, evoking a sense of enchantment and holiday magic."
      },
      {
        product_name: "Winter Gathering",
        product_id: "6943527665730",
        product_text: "In the heart of a winter wonderland, a heartwarming scene unfolds—a gathering of Santa Claus and his forest friends amidst a pristine blanket of snow, embodying the essence of companionship, kindness, and the joy of shared moments."
      },
      {
        product_name: "Back to School",
        product_id: "6939420786754",
        product_text: "A lively tableau of kids with their furry friends gazes at the window of a back-to-school supplies store with fascination. The glass becomes a canvas, offering a glimpse into a world where anticipation, wonder, and youthful curiosity merge in a symphony of vibrant energy."
      },
      {
        product_name: "Springtime Hideaway",
        product_id: "6939423375426",
        product_text: "A tranquil springtime hideaway where nature takes center stage. A symphony of colors, textures, and fragrances dances through the air. As the sun's gentle rays kiss the earth, the garden becomes a canvas of life, where every corner blooms with the promise of renewal and growth."
      },
      {
        product_name: "Ahyoka",
        product_id: "6939563491394",
        product_text: "A soft embrace of natural light casts a gentle glow on Ahyoka and her furry friend. The leaves filter the sunlight, creating a play of shadows that dance across their forms, adding an almost ethereal quality to their interaction."
      },
      {
        product_name: "Charlie",
        product_id: "6939571290178",
        product_text: "Surrounded by a profusion of flowers in various shades of pink, green, and purple hues, Charlie becomes a part of the symphony of color and life. The blossoms seem to dance with delight as they frame his antics, creating a scene brimming with springtime charm."
      },
      {
        product_name: "Pink Mushroom Cottage",
        product_id: "6939585052738",
        product_text: "Nestled among a forest of towering trees, this charming abode stands as an enchanting testament to the whimsy of the natural world. Resembling a giant pink mushroom beckons all who stumble upon it to enter a realm of fairy tales and dreams."
      },
      {
        product_name: "Wild World",
        product_id: "6939557953602",
        product_text: "A vibrant world where the wild and the delicate coexist in perfect harmony. Against a backdrop of lush foliage and blossoms, a diverse cast of wild animals emerges from their natural habitat, creating a mesmerizing tableau of life and color."
      },
      {
        product_name: "Sea Turtle",
        product_id: "6939587477570",
        product_text: "An enchanting journey into the ethereal world where the ocean and nature's beauty converge. At its heart, a majestic sea turtle emerges from the depths, carrying a woman who seems to ride the waves of the ocean and the currents of her imagination."
      },
      {
        product_name: "Spirit of a Lion",
        product_id: "6939580072002",
        product_text: "The king of the savannah—in a kaleidoscope of vivid hues. Its majestic mane, thick and luxurious, frames its noble face, which is adorned with piercing eyes that seem to hold the wisdom of ages."
      },
      {
        product_name: "Claudia",
        product_id: "6896269426754",
        product_text: "A mix of longing and melancholy, as if caught between the innocence of her past and the vampiric existence she now embraces. The juxtaposition of the teddy bear and the glass of blood encapsulates the complexity of Claudia’s character –a haunting blend of beauty and the supernatural."
      },
      {
        product_name: "Stairway to Serenity",
        product_id: "6909573103682",
        product_text: "A flight of sturdy stone stairs adorned with a vibrant tapestry of flowers unfolds before your eyes, leading you on a delightful journey. Each step is a visual treat, as colorful blooms cascade gracefully, draping the edges of the steps like a floral waterfall."
      },
      {
        product_name: "Everything’s Better With Ice Cream",
        product_id: "6939415314498",
        product_text: "A charming ice cream cart adorned with bright, pastel colors, stands on a sandy beach serving a delightful assortment of ice cream cones, cups, and popsicles. A scene of pure joy and summertime happiness, capturing the essence of a perfect sunny day filled with sweet moments and childhood wonder."
      },
      {
        product_name: "Balloons Over Cottage Cove",
        product_id: "6939424063554",
        product_text: "A breathtaking coastal scene where a majestic fleet of hot air balloons takes flight. Each balloon is a radiant burst of color against the sky, showcasing a variety of designs and patterns. They rise gracefully into the air, creating a captivating contrast with the tranquil seascape below."
      },
      {
        product_name: "Gnome Home Glow",
        product_id: "6939580825666",
        product_text: "A tranquil beauty of the gnome's abode. A place where the whimsy of the forest blends seamlessly with the charm of pastel colors, creating a delightful and inviting home for its gnome inhabitants."
      },
      {
        product_name: "Rainbow Dragon",
        product_id: "6939587969090",
        product_text: "A majestic dragon, resplendent in its iridescent glory. Its scales are like glistening gemstones, each one capturing a different color of the rainbow. As the light plays upon them, they emit a radiant and prismatic display, evoking a sense of wonder and magic."
      },
      {
        product_name: "Buca Di Francesco",
        product_id: "6939573026882",
        product_text: "The colorful flowers, the tranquil canal, and the inviting restaurant setting encapsulate the essence of Assisi's beauty and the rich culinary traditions of Italy. A place where nature and gastronomy converge to create an unforgettable dining experience."
      },
      {
        product_name: "Petra",
        product_id: "6939567423554",
        product_text: "Petra is depicted in a regal pose. Its plumage is a breathtaking fusion of vivid colors that create a mesmerizing scene capturing the essence of the bird's natural beauty and radiating a sense of vibrancy and life."
      },
      {
        product_name: "Silent Night",
        product_id: "6943525404738",
        product_text: "Amidst the tranquil embrace of a pristine winter's day, a quaint chapel emerges as a beacon of solace and hope. Nestled within a majestic grove of snow-capped trees, this sacred haven stands as a testament to unwavering faith and the enduring splendor of the natural world."
      },
      {
        product_name: "Welcome To Christmas",
        product_id: "6943526158402",
        product_text: "A tranquil Christmas scene near the lighthouse, where the world is hushed, and hearts are aglow with the magic of the holiday season. A moment of serene beauty and timeless joy, where the spirit of Christmas envelops all who behold it, reminding them of the boundless love and goodwill that this special time of year brings."
      },
      {
        product_name: "Dogs Watching Santa",
        product_id: "6943526748226",
        product_text: "High in the night sky, Santa Claus is depicted in his white suit, driving his sleigh filled with gifts. A beautiful moment that fills our furry companions with wonder as they watch Santa and his reindeer on their magical journey mirroring the delight and excitement that fills our hearts during the holiday season."
      },
      {
        product_name: "Christmas Mailbox",
        product_id: "6943527239746",
        product_text: "A timeless beauty and nostalgic charm of a winter's day during the Christmas season, where the mansion and its Christmas mailbox are adorned with vibrant red bows and a lush evergreen tree entwined with shimmering fairy lights, embodying the warmth, love, and festive excitement that this holiday season brings."
      },
      {
        product_name: "Our Madness",
        product_id: "6896270377026",
        product_text: "Dive into the world of whimsical madness, where Alice takes a wild journey alongside her enigmatic companion, the Purple Cheshire Cat. Get ready to unravel the secrets of Wonderland and embrace the magic that lies beyond the looking glass."
      },
      {
        product_name: "Dream Home",
        product_id: "6939588264002",
        product_text: "Step into the magical allure of this breathtaking house nestled deep within the forest and let your imagination take flight. Captivating, whimsical, and straight out of a storybook, this hidden gem is sure to leave you spellbound. Dare to dream and get lost in the wonder of it all."
      },
      {
        product_name: "October Skies",
        product_id: "6909572939842",
        product_text: "A splendid autumn day where a magnificent mansion becomes a picturesque backdrop to a delightful display of pumpkins and the vibrant beauty of fall flowers, creating a scene of warmth, charm, and seasonal wonder."
      },
      {
        product_name: "A Mother’s Love",
        product_id: "6939408924738",
        product_text: "A heartwarming scene of a charming little girl and her feline companion at the edge of a serene, flower-fringed pond. Captivated by the beauty of nature, they watch a family of ducks with unbridled delight as they glide gracefully across the water's surface."
      },
      {
        product_name: "Spooky Sunset",
        product_id: "6961283792962",
        product_text: "In the eerie glow of a spooky sunset, the sky is ablaze with fiery hues of deep orange and purple. A rusty, weathered truck sits abandoned in a field adorned with a cluster of sunflowers and pumpkins. Some are carved into eerie Jack-o'-lanterns, their wicked grins flickering with candles from within, while others remain untouched, waiting to be transformed into spooky decorations."
      },
      {
        product_name: "A Spooky Night",
        product_id: "6960054829122",
        product_text: "A foreboding sense of dread permeates the air as a spooky house looms in the distance, casting eerie shadows in the chilling breeze. Tombstones, weathered and crooked, jut out of the ground like jagged teeth, bearing the names of long-forgotten souls. The night is alive with the whispers of the unknown, a place where fear and mystery intertwine, and where the line between the living and the spectral blurs."
      },
      {
        product_name: "Eeries Coven",
        product_id: "6960029859906",
        product_text: "A whimsical and enchanting tableau of a mysterious witch, dressed in a traditional black pointed hat and elegant ball gown. Surrounded by a circle of luminescent jack-o'-lanterns, their carved faces illuminated by flickering candlelight. Each pumpkin seems to possess a unique personality, with grinning, sinister, or goofy expressions, casting eerie and playful shadows with the deep, inky darkness of the night."
      },
      {
        product_name: "Haunted Farmyard",
        product_id: "6961283268674",
        product_text: "In the moonlight's eerie glow, a Haunted Farmyard comes to life, shrouded in an aura of unsettling mystery. An old, weather-beaten farmhouse where windows emit a ghostly glow. The farmyard is silent, save for the occasional creaking of the dilapidated structures and the distant hoot of an owl, as if the very air is charged with the weight of forgotten memories and restless spirits."
      },
      {
        product_name: "Little Tricksters",
        product_id: "6961289920578",
        product_text: "A bewitching autumn night, where the realms of reality and fantasy intertwine. This feline trickster dons a pointed witch's hat, adding an element of whimsy to its mysterious presence beside a vigilant crow fixated on something in the distance, casting an aura of curiosity and foreboding over the scene."
      },
      {
        product_name: "Trick or Treating",
        product_id: "6960059613250",
        product_text: "In a quaint suburban neighborhood, under the shadow of the harvest moon, each furry trick-or-treater holds a miniature trick-or-treat bucket ready to collect some Halloween treats. A perfect fall night filled with warm, festive feeling, capturing the joy and magic of Halloween night in a world where even our furry friends get to join in the fun."
      },
      {
        product_name: "Moonlight Stroll",
        product_id: "6961269342274",
        product_text: "Get lost in the mesmerizing beauty of Moonlight Stroll. Against a backdrop of moonlight hues, her enigmatic figure strides through an ethereal setting, immersing us in a realm where beauty and malevolence dance hand in hand. In her arms, she cradles a Rushton doll, a vintage collectible known for its innocent and cherubic appearance –cherished and slightly eerie, evoking a sense of nostalgia and a connection to the uncanny."
      },
      {
        product_name: "All Hallow’s Eve",
        product_id: "6961278484546",
        product_text: "A spine-chilling tableau of a spooky night, where the supernatural seems to come alive, and the line between the living and the dead blurs into a haunting and atmospheric scene. An eerie sight of wicked witches, jack-o'-lanterns, tombstones, and ghosts are lurking in the shadows. Come explore the darkness if you dare!"
      },
      {
        product_name: "Halloween Gnome",
        product_id: "6960189931586",
        product_text: "Fringed with cobwebs and a sense of wonder, this charismatic Halloween Gnome dressed in a deep green cloak, a pointed starry hat, and striped stockings is ready to take us on a magical adventure. A night when the ordinary becomes extraordinary, and even a humble gnome can become a guardian of the mystical realm."
      },
      {
        product_name: "Graveyard Hill",
        product_id: "6960072261698",
        product_text: "In a dimly moonlit tableau, a foreboding hill rises in the distance, crowned with a haunted house. On the hillside, a centuries-old graveyard stretches with crooked tombstones, some leaning precariously. Sinister jack-o’-lanterns line the path leading to the house, casting eerie glows, invoking the magic and mystery of Halloween night, where the veil between the living and the dead is at its thinnest."
      },
      {
        product_name: "The Game is Afoot",
        product_id: "6960056008770",
        product_text: "The moon hung low in the inky sky, casting a silvery sheen upon the rolling hills of the English countryside. The air was cool and still, save for the occasional rustling of leaves in the gentle breeze. The Game is Afoot as Holmes and his loyal companion, Watson, are hot on the trail of another perplexing case, and the scene before them seemed to set the stage for the mystery that awaited."
      },
      {
        product_name: "Cornucopia",
        product_id: "6960185016386",
        product_text: "Bathed in the warm, golden glow of the setting sun, a beautifully woven cornucopia overflows with an abundant harvest of sunflowers, grapes, and pumpkins –a testament to the season's generosity, a reminder that the Earth's bounty is a gift to be celebrated."
      },
      {
        product_name: "Halloween Tricksters",
        product_id: "6961280811074",
        product_text: "Step into a world where the boundary between reality and fantasy blurs under the silvery glow of a full moon. A group of whimsical furry tricksters with their miniature trick-or-treat pumpkin buckets are gathered around a cluster of plump, beautifully carved pumpkins –embodying the playful and enigmatic spirit of the season."
      },
      {
        product_name: "Autumn Dreams",
        product_id: "6960063971394",
        product_text: "The sky above is a brilliant azure, unmarred by a single cloud. Casting a gentle, slanted light that gives everything a soft, almost magical quality. It’s as though this sleepy feline is lost in its own dreams while a curious mouse is making a stealthy approach towards atop the pumpkin, driven by the temptation of adventure or perhaps the hope of sharing the cozy pumpkin spot."
      },
      {
        product_name: "Moon Raven",
        product_id: "6960187080770",
        product_text: "Under the mesmerizing glow of a full moon, a raven, with feathers that gleam like polished obsidian, perches gracefully on a twisted pine branch. Its keen eyes, filled with age-old wisdom, seem to pierce the very heart of the night, while the rugged pines that stretch infinitely into the distance stand as silent sentinels, their needles catching the moonlight in a delicate dance of shadows and light."
      },
      {
        product_name: "Come Little Children",
        product_id: "6961275633730",
        product_text: "A whimsical witch hat adorned with a bewitching assortment of candies, appears as though it was plucked straight from the dreams of a playful sorceress –creating a delightful and almost tempting contrast with the dark, magical atmosphere of the scene."
      },
      {
        product_name: "Pumpkin Patch Farm",
        product_id: "6961282777154",
        product_text: "Take a step back from the bustling modern world and appreciate the simple, yet profound, pleasures of a Pumpkin Patch Farm in the heart of autumn. Capturing the essence of fall and the abundance it brings, making it an enduring symbol of the season's warmth, bounty, and the enduring beauty of rural life."
      },
      {
        product_name: "Haunted Halloween Library",
        product_id: "6960069509186",
        product_text: "An enchanting and eerie ambiance of the Haunted Library on a moonlit Halloween night. A lone girl sits on a creaky wooden chair, oblivious to the otherworldly horrors around her.. Amidst this spectral tableau, sinister jack-o'-lanterns cast flickering, malevolent glows. Their carved, sinister faces leered from the shadows, grinning with jagged, toothy smiles, and their wicked, triangular eyes seemed to follow your every move."
      },
      {
        product_name: "Moonlight Manor",
        product_id: "6960071409730",
        product_text: "A juxtaposition of childhood innocence and the mystery of Halloween night, where the allure of candy and adventure intertwines with the chilling tales of haunted houses. Moonlight Manor's dark facade, with its history of ghostly legends, creates a spine-tingling backdrop for the brave trick-or-treaters embarking on their spooky Halloween journey."
      },
      {
        product_name: "Happy Halloween",
        product_id: "6960390635586",
        product_text: "As the pale moon hung high in the midnight sky, casting its ethereal glow over an ancient cemetery, a bewitching scene unfolded beneath its watchful gaze. A feline enchanter adorned in a miniature witch's hat is perched upon its pumpkin throne as the guardian of the night, overseeing a world where magic reigns, and the spirits of the past come to life."
      },
      {
        product_name: "Halloween Night",
        product_id: "6961274093634",
        product_text: "In the moonlit graveyard, ancient tombstones and weathered mausoleums stand like silent sentinels in the mis, punctuated by the cackles of the witches and the soft, mournful wails of the ghosts. Among the graves, a congregation of menacing jack-o'-lanterns, each carved with a malevolent grin, casting ominous glows. Their candle flames flicker like malicious spirits."
      },
      {
        product_name: "Night Flight",
        product_id: "6961270489154",
        product_text: "In the dim light of a foggy cemetery, a lady dressed in an ethereal shade of pink clutches a grumpy, yet endearing pet standing in the midst of gravestones, her attire contrasting starkly with the eerie, mist-shrouded environment. Her presence is captivating, as she seems to blend into the hazy, dreamlike atmosphere."
      },
      {
        product_name: "Halloween House",
        product_id: "6961270849602",
        product_text: "In a moonlit October night, the sinister silhouette of a Halloween House looms against the inky sky, casting eerie shadows over the land – a beacon for all things spooky and supernatural. A ghastly scarecrow stands guard, its tattered and ragged clothes hanging from a twisted, gnarled frame while bats, winged phantoms of the night, swirl around the house, their ghostly forms outlined by the silvery glow of the moon."
      },
      {
        product_name: "Decorating the Haunted House",
        product_id: "6961282154562",
        product_text: "Nestled deep within a shadowy forest, a grand mansion bathed in moonlight stood as a beacon of Halloween enchantment. With intricate architecture and gleaming windows adorned by grinning jack-o'-lanterns, the house buzzed with ethereal spirits, mischievous skeletons, and spectral felines. Surrounding trees, skeletal in their autumn bareness, framed the mansion, while a slightly ajar wrought iron gate beckoned the adventurous closer."
      },
      {
        product_name: "Haunted Moon",
        product_id: "6960062627906",
        product_text: "Under a luminous moon, a splendid mansion with walls of lilac and rose stood proudly. Glowing pumpkins cast playful shadows, while a raven traced the sky, enhancing the realm's mystique. Two eager children, whispers of excitement in the air, approached the mansion, drawn by the promise of Halloween treats. Amid this bewitching tableau, two black cats held vigil, their watchful eyes capturing the spirit of the evening."
      },
      {
        product_name: "Witch is Mummy",
        product_id: "6960072949826",
        product_text: "In the midst of an eerie chamber, a family of mysterious creatures gathered, their presences magnified by the vibrant orange hue of the moon seeping through the window. Their figures, intertwined with whispers of ancient tales, formed a tableau of haunting beauty. High above, a silent owl kept vigil, encapsulating the room's otherworldly essence."
      },
      {
        product_name: "Boo’s Halloween",
        product_id: "6960054009922",
        product_text: "Beneath the vast expanse of a twilight sky, a curious feline adorned with a whimsical witch's hat gazes intently, its two-toned eyes mirroring the mysteries of the universe. Nestled below, a cheeky mouse perches atop a vibrant apple, seemingly ready to embark on a nocturnal adventure. Framing this scene, sunflowers and wildflowers stand tall, silently witnessing the enchanting interplay between the moon's golden embrace and the creatures of the night."
      },
      {
        product_name: "Harvest Helper",
        product_id: "6939560575042",
        product_text: "In this enchanting display of fall colors, a charming dog sits proudly atop a wooden bucket overflowing with freshly harvested apples and flowers in various shades of red, orange, and yellow bloom. His expressive eyes exude a sense of loyalty and contentment. The dog seems to be guarding the bountiful harvest of apples that have just been picked from the nearby orchard."
      },
      {
        product_name: "Cobblestone Fountain",
        product_id: "6939423768642",
        product_text: "Cascading water flows from the fountain's top into a circular pool below, creating a soothing melody that perfectly complements the visual masterpiece. The fragrance of the flowers seems to hang in the air, and the serene ambiance invites visitors to pause and reflect, creating a moment of tranquility in the heart of this elegant hotel's courtyard."
      },
      {
        product_name: "Coming up Roses",
        product_id: "6939411611714",
        product_text: "In a picturesque village corner, a sunlit cottage with weathered white walls stood adorned with blooming roses, geraniums, and morning glories. Nearby, three young girls played amidst roses, transforming petals into storytellers weaving tales of magical meadows and hidden gardens. In this serene setting, the cottage and its surroundings harmoniously whispered stories of eternal innocence and the allure of nature's beauty."
      },
      {
        product_name: "Honey",
        product_id: "6939561492546",
        product_text: "A beautiful fairy with delicate, gossamer wings alights upon a vibrant mushroom, its cap a brilliant shade of crimson, dotted with small, white speckles. A profusion of wildflowers surrounds her, their petals swaying in the gentle breeze. You can almost hear the faint hum of nature's magic and the distant song of woodland creatures celebrating the fairy's harmonious existence with the natural world."
      },
      {
        product_name: "Pretty Rose Princess",
        product_id: "6939585249346",
        product_text: "In a world where magic and reality intertwine, there exists a mystical Princess adorned in the pure elegance of the roses, where each bloom seems to whisper tales of forgotten magic and forgotten love. The castle, a grand and majestic structure, stands proudly in the background, its spires reaching toward the heavens."
      },
      {
        product_name: "Fore The Good Times",
        product_id: "6939577286722",
        product_text: "Welcome to the ultimate entertainment sanctuary – whether you're a golf enthusiast, a gaming aficionado, or simply looking for a luxurious space to relax and socialize, this arcade room offers the perfect blend of entertainment, sports, and indulgence. It's where you can swing your clubs, enjoy your favorite drinks, and create unforgettable memories fore the good times, all in one exquisite setting."
      },
      {
        product_name: "Rico",
        product_id: "6939570765890",
        product_text: "A tranquil symphony of colors that instantly transports you to a serene wetland oasis. Surrounding the enchanting flamingo are lush, tropical flowers in full bloom mirroring its posture with a natural grace of its own. A dreamlike fusion of nature's beauty, where the flamingo and flowers coexist in perfect, pastel harmony—a visual poem that captures the spirit of a tranquil wetland sanctuary."
      },
      {
        product_name: "Raptor",
        product_id: "6939578826818",
        product_text: "In the shadows, a radiant raptor glides, leaving a trail of sparkling energy that weaves an ephemeral tapestry mirroring its movements. The magical display evokes celestial constellations, as if stars have descended to accompany this enigmatic being on its nocturnal journey."
      },
      {
        product_name: "Wishing You a Rainbow",
        product_id: "6939422195778",
        product_text: "A charming garden comes alive with a symphony of colors and motion, as the girl carefully waters the plants, each drop seems to glisten like a tiny gem, catching the early morning sun's rays and creating a magical, shimmering rainbow effect. A serene moment where the essence of childhood wonder and the joys of nature converge in perfect harmony."
      },
      {
        product_name: "Parrot Priestess",
        product_id: "6939586625602",
        product_text: "Step into a world where every element sings with enchantment, and where the Parrot Priestess, a guardian of dreams and nature, reigns with a soft but unyielding power - a power that is gentle yet omnipotent, nurturing yet awe-inspiring. An embodiment of the earth's whispered secrets and the sky's boundless dreams."
      },
      {
        product_name: "Bay's Landing",
        product_id: "6939428880450",
        product_text: "A serene and nostalgic lakeside scene that will transport you to a bygone era, where time seems to slow, and life is savored one moment at a time - capturing the essence of a peaceful retreat, a place where the past and present merge in a harmonious dance of beauty and tranquility, inviting us to linger and find solace in the timeless embrace of nature and architecture."
      },
  
];//Do not remove this ];
